//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------
import { filter, find, groupBy, map, get, uniqBy } from 'lodash';
import React, { useCallback, useEffect, useMemo, useState, useRef } from 'react';
import { createPortal } from 'react-dom';
import styled from 'styled-components';
//  -- Components ---------------------
import { Close, Search, Check, CancelOutlined, MenuBook  } from '@mui/icons-material';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import { Col, Dropdown, Select } from 'antd';
import Loading from 'components/Loading';
import { PieChart, Pie, Cell } from 'recharts';
import { CologG, LogoOnExam, TableBg, SelectDownArrow, OneWayEducationLogo } from "utils/assets/images";
import { Modal, TablePagination } from '@mui/material';
import FlatList from "flatlist-react";
import { useReactToPrint } from 'react-to-print';
import { useMobileDetect, useTabletDetection } from 'containers/chat/hooks';
import { addPrintableClass, removePrintableClass } from 'utils/methods/textMethod';
import { useAlert } from 'components/UI/alertSakeBar/alertProvider';
import { handleGetStudentSubmissionDetailsProficiency } from 'store/standardexams';
import { Spin, Skeleton } from 'antd';
import PrintIcon from '@mui/icons-material/Print';
import InfoOutlineIcon from '@mui/icons-material/InfoOutline';
import CloseIcon from '@mui/icons-material/Close';
import {
    BarChart,
    Bar,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    Legend,
    LabelList,
    ResponsiveContainer,
} from "recharts";
//  -- Constants ----------------------
import COLOR from 'utils/constants/color';

//  -- Features -----------------------

//  -- Thunks -------------------------
import { TootipWrapper } from 'components/TooltipWrapper';
import { Button } from '@mui/material'
import { CaretDownOutlined, DownloadOutlined, ReloadOutlined } from '@ant-design/icons';
import * as Sentry from '@sentry/react';
import OverallModal from 'containers/district_admin/OverallModal';
import SentryWrap from 'components/Sentry';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useCurrentUser } from 'store/users/selectors';
import { useCurrentClass } from 'store/classes/selectors';
import { useClassUsers, useUserClasses, useUsersByClass } from 'store/userClasses/selectors';
import { mergeExamUserWithClassRoster, resolveGradebookRosterRaw, studentMatchesGradebookActiveFilter } from 'utils/methods/gradebookStudentActiveFilter';
import { handleListExamDataByConfig, handleCreateDownloadList } from 'store/exams/thunks';
import dayjs from 'utils/dayjsConfig';
import SpinLoader from 'components/Loader/SpinLoader';
import { Rnd } from 'react-rnd';
import styles from './ExamGradeTable.module.css';
const ACTIVE_BTN_COLOR = `linear-gradient(to bottom right, ${COLOR.indigo100} , ${COLOR.indigo300})`
const DEACTIVE_BTN_COLOR = `linear-gradient(to right, ${COLOR.lightseagreen100} , ${COLOR.lightseagreen200})`
const getBgColor = (isActive) => isActive ? ACTIVE_BTN_COLOR : DEACTIVE_BTN_COLOR
const PLACEMNETCOLOR = [COLOR.greentrue, COLOR.green900, COLOR.yellow, COLOR.blueish100, COLOR.orange100, COLOR.radish100, , COLOR.red]
const ACIFL_LEVEL = ['ADV HIGH ', 'ADV MID', 'ADV LOW', 'INTER HIGH', 'INTER MID', 'INTER LOW', 'NOVICE HIGH', 'NOVICE MID', 'NOVICE LOW', 'FALTANTES']
const ACIFL_LEVEL_ABBR = ['AH ', 'AM', 'AL', 'IH', 'IM', 'IL', 'NH', 'NM', 'NL', 'FA']

const convertPlacementToAbbr = (placement) => {
    if (!placement) return '-';
    if (placement === 'NOT ASSIGNED') return 'NA';
    if (placement === 'NOT STARTED') return 'NS';
    if (placement === 'NOT FINISHED') return 'NF';
    const index = ACIFL_LEVEL.findIndex(level => level === placement);
    if (index !== -1) {
        return ACIFL_LEVEL_ABBR[index] || placement;
    }
    return placement;
}
const EXAM_SCHOOLS = ['HIGH SCHOOL', 'MIDDLE SCHOOL']
const EXAM_SCHOOLS_ABBR = ['high', 'middle']
const EXAM_LABELS = ['Interpretativa(A)', 'Interpretativa(B)', 'Comprensión lit..', 'Comprensión aud..', 'Comunicación int..', 'Presentación']
const EXAM_LABELS_FULL = ['Interpretativa(A)', 'Interpretativa(B)', 'Comprensión literaria', 'Comprensión auditiva', 'Comunicación interpersonal', 'Presentación oral informal']
const MAX_TABLE_COLUMNS = EXAM_LABELS.length + 1
const SECTION_MAX_POINTS = ['', 20, 20, 12, 14, 17, 17];

function containsNumber(arr) {
    return arr.some(item => !isNaN(item) && typeof item !== 'boolean');
}

const domainData = [
    { name: "Listening", value: 0 },
    { name: "Speaking", value: 0 },
    { name: "Reading", value: 0 },
    { name: "Writing", value: 0 },
];

const flagData = [
    {
        title: "Red = Urgent Support (high 50% failing, downward trend).", backgroundcolor: 'linear-gradient(180deg,#ef476f,#d7265e)',
    },
    {
        title: "Orange = Needs Attention (moderate 25% failing, stagnant growth).", backgroundcolor: 'linear-gradient(180deg, #FFB703, #FB8500)',
    },
    {
        title: "Green = Sufficient Support (low 10% failing, stable growth).", backgroundcolor: 'linear-gradient(180deg, #03989e, #03989e)'
    }
]
const years = new Date().getFullYear();
const upcomming_year = `${years}-${years + 1}`;
const downcomming_year = `${years - 1}-${years}`;

const config = {
    chart: {
        plotBackgroundColor: null,
        plotBorderWidth: 0,
        plotShadow: false,
        marginTop: 0,
        spacingLeft: 0,
        spacingRight: 0,
        spacingTop: 0,
        height: 120,
        width: 120,
        animation: true,
        backgroundColor: "transparent",
    },
    title: {
        text: "0%",
        align: "center",
        verticalAlign: "middle",
        y: 15,
        style: {
            fontWeight: 200,
            fontSize: "14px",
        },
    },
    tooltip: {
        enabled: true,
        formatter: function () {
            return `${this.key ?? ""}` + ":" + this.y + "%";
        }
    },
    accessibility: {
        point: {
            valueSuffix: '%'
        }
    },
    plotOptions: {
        pie: {
            cursor: "pointer",
            dataLabels: {
                enabled: false,
            },
            startAngle: -90,
            endAngle: 90,
            center: ['50%', '75%'],
            size: '110%',
            showInLegend: false,
            borderWidth: 0,
            colors: ["rgb(90,177,208)", COLOR.gray100],
        }
    },
    series: [{
        type: 'pie',
        name: '',
        innerSize: '50%',
        data: [
            ['', 50.0],
            ['', 50.0],
        ]
    }]
};
const chartColors = ["rgb(90,177,208)", COLOR.gray100];
const chartConfig = {
    height: 88,
    width: 96,
    innerRadius: '62%',
    outerRadius: '82%',
    startAngle: 180,
    endAngle: 0,
    titleStyle: {
        fontWeight: 400,
        fontSize: "11px",
    }
};

//  ----------------------------------------------------------------------------
//  Styles
//  ----------------------------------------------------------------------------
const ExamPerformanceChartWrap = styled.div`
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    justify-content: space-between;
    padding: 10px;
    // @media (max-width: 475px){
    // overflow: auto;
    // }
`;

const OverflowTwo = styled.div`
    height: auto;
    overflow-x: auto;
    scrollbar-width: auto;
    scrollbar-color: #b5b5b5 #f1f1f1;
    width: 70%;
    display: inline-block;
    border-right:1px solid black;
    &::-webkit-scrollbar {
        height: 16px;
    }
    &::-webkit-scrollbar-track {
        background: #f1f1f1;
    }
    &::-webkit-scrollbar-thumb {
        background: #b5b5b5;
        border-radius: 8px;
    }
    @media (max-width: 634px) {
        width: 50%;
    }
`;

const OneLogoRow = styled.div`
  display: flex;
  flex-direction: row;
`;
const TableHeader = styled.div`
    display: flex;
    flex-direction: row;
    padding: 0px 8px 4px 8px;
    margin-bottom: 4px;
`;

const Wrapper = styled.div`
    width: 100%;
`;

const NameContent = styled.span`
    color: #fff;
    margin-left: 10px;
    width: 220px;

`;
const StudentNameTable = styled.div`
    display: flex;
    flex-direction: column;
    width: 230px;
    height:40px;
    padding-right: 20px;
    padding-top: 2px;
    padding-bottom: 2px;
    `;
const StudentName = styled.span`
    color: #fff;
    font-size: 16px;
    font-weight: 600;
    background-color: #5271ff;
    width: 95%;
    height: 40px;
    padding-left: 10px;
    padding-top: 5px;
    padding-right: 10px;
    border-radius: 5px;
    display:flex;
    justify-content: space-between;
    align-items: center;
    flex-direction: row;
    min-width: 0;
`;
const StudentNameText = styled.span`
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    flex: 1;
    min-width: 0;
`;
const QuestionTab = styled.span`
    color: #fff;
    font-size: 16px;
    font-weight: 600;
    background-color: #6ca642;
    width: 95%;
    height: 40px;
    padding-left: 10px;
    padding-top: 5px;
    border-radius: 5px;
    display:flex;
    justify-content: flex-start;
    align-items: center;
    border: 1px solid white;
`;
const HeaderTab = styled.div`
    height:25px;
    color: #FFFFFF;
    text-align: center;
    margin-top: 5px;
    border-radius: 5px;
    justify-content: center;
    align-items: center;
    font-size: 12px;
    text-overflow: ellipsis;
    white-space: nowrap;
    padding:0px 5px;
    padding: 3px 5px;
    display:flex;
    overflow: hidden;
    font-weight: 500
`;
const HeaderTabP = styled.div`
    height:25px;
    color: white;
    text-align: center;
    margin-top: 5px;
    border-radius: 5px;
    justify-content: center;
    align-items: center;
    font-size: 12px;
    padding: 3px 5px;
    display:flex;
    overflow: hidden;
    font-weight: 500
`;
const TableTopBtnCont = styled.div`
    justify-content: center;
    align-items: center;
    padding-left: 1.5%;
    overflow: hidden;
    display: flex;
    padding-left:5px;
    padding-right:5px;
`;
const TopTabCont = styled.div`
    display:flex;
    flex-direction:row;
`;
const TotalNStudentTxt = styled.span`
    font-size: 14px;
    font-weight: 600;
    margin: 0;
    white-space: nowrap;
    color: #333;
    `;
const Exam2TableHeader = styled(TableHeader)`
    background-color: #8946A6;
    height:45px;
    border-radius:5px;
    align-items:center;
`;
const ChartContainer = styled.div`
    display:flex;
    flex-direction:row;
    width:100%;
    @media (max-width: 992px) {
       width:100%;
    }
    
`;
const ChartContainerInner = styled.div`
    display:flex;
    flex-direction:column;
    justify-content: center;
    align-items: center;
    height:50px;
    margin-left:10px;
    margin-right:10px;
`;
const ChartLabel = styled.span`
    font-size: 15px;
    font-weight: 600;
`;
const SearchBox = styled.input`
  background-color: transparent;
  border: none;
  border-radius: 7px;
  color: ${COLOR.white};
  font-size: 14px;
  font-weight: 400;
  height: 30px;
  outline: none;
  padding: 2px 16px;
  width: 90%;
  margin-right: 2px;
  margin-left: 2px;
  ::placeholder,
  ::-webkit-input-placeholder {
    color: #fff;
  }
  :-ms-input-placeholder {
    color: #fff;
  }
  @media (max-width: 992px) {
    margin-top: 10px;
    margin-bottom: 10px;
  }
`;
const SearchBoxContainer = styled.div`
    display: flex;
    flex-direction: row;
    border-radius: 5px;
    background-color:rgb(126,112,165);
    color: ${COLOR.green};
    font-size: 14px;
    align-items: center;
    width:100%;
    padding-right:12px;
    height: 30px;
    @media (max-width: 992px) {
       min-width:200px;
       margin-bottom:30px;
      }
    @media (max-width: 500px) {
        width:75vw;
    }   
`;
const ExamTableSection1 = styled.div`
    display: flex;
    flex-direction: column;
    width: 230px;
    justify-content: space-between;
    `;
const ExamTableSection2 = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    @media (max-width: 992px) {
        width: 100%;
    }
    `;
const ExamTableEmptyState = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 120px;
    padding: 24px 16px;
    width: 100%;
    box-sizing: border-box;
    font-size: 14px;
    font-weight: 500;
    color: #555;
    text-align: center;
    background-color: rgb(242, 248, 254);
    border-radius: 8px;
    margin-top: 8px;
`;
const TableItem = styled.td`
    height:40px;
    width: 25%;
    border-collapse: collapse;
    text-align:center;
    padding-top: 10px;
    `;
const ExamGradeTable = styled.table`
  border-collapse: collapse;
`;
const ExamGradeBoday = styled.tbody`
`;
const ExamRow = styled.tr`
    display: flex;
    flex-direction: row;`;
const PlacementText = styled.span`
       color:${p => p.textColor ? p.textColor : COLOR.gray100}
    `;
const GraphRow = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 12px;
    min-width: 0;
   @media (max-width: 992px) {
    flex-direction: column;
    align-items: flex-start;
    }

`;
const ExamOverflowTwo = styled(OverflowTwo)`
    width:90%;
    border-right: 0px;
    @media (max-width: 992px) {
        width:100%;
    }
    `;
const CloseBtn = styled.span`
    font-size: 12px;
    font-weight: 600;
    cursor: pointer;
    margin-left: 10px;
    margin-top: 10px;
    align-self: flex-end;
    display:flex;
    flex-direction:row;
    color:#FF0000;
    justify-content: flex-end;
    `;
const ExamGradeSec = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    background-image:url(${TableBg});
    background-size: cover;
    padding:16px;
    margin-bottom:60px;
    @media (max-width: 600px) {
        background-position: bottom;
    }
`;

const ModalRndAnchor = styled.div`
  outline: none;
`;

const ModalWrapper = styled.div`
  position: relative;
  z-index: 1;
  box-sizing: border-box;
  width: min(900px, calc(100vw - 48px));
  min-width: min(300px, calc(100vw - 48px));
  min-height: min(720px, 72vh);

  @media (max-width: 1024px) {
    min-height: min(420px, 52vh);
  }

  @media (max-width: 600px) {
    width: calc(100vw - 24px);
    min-height: min(360px, 56vh);
  }

  @media (pointer: coarse) and (min-width: 744px) {
    min-height: min(700px, 86vh);
  }

  @media (pointer: coarse) and (max-width: 743px) {
    min-height: min(380px, 70vh);
  }

  @media print {
    position: relative !important;
    top: auto !important;
    right: auto !important;
    width: 100% !important;
    min-width: 0 !important;
    min-height: 0 !important;
    margin: 0 !important;
    padding: 0 !important;
    z-index: 1 !important;
  }
`;

const ModalTopDragHandle = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 34px;
  cursor: move;
  z-index: 2;
  touch-action: none;
  background: rgba(255, 255, 255, 0.3);
  border-radius: 12px 12px 0 0;

  @media (pointer: coarse) {
    height: 44px;
  }
`;

const FlagModalWrapper = styled.div`
  position: relative;
`;

const FlagModalDragHandle = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 34px;
  cursor: move;
  touch-action: none;
  border-radius: 10px 10px 0 0;

  @media (pointer: coarse) {
    height: 44px;
  }

  @media print {
    display: none !important;
  }
`;

const FlagPortalSurface = styled.div`
  position: fixed;
  inset: 0;
  z-index: 2147483000;
  pointer-events: none;
  isolation: isolate;

  & > * {
    pointer-events: auto;
  }
`;

const ModalOverlay = styled.div`
  position: fixed;
  inset: 0;
  z-index: 1300;
  background: rgba(0, 0, 0, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;

  @media print {
    position: static !important;
    background: transparent !important;
    padding: 0 !important;
  }
`;

const CloseButtonWrapper = styled.div`
  position: absolute;
  top: 8px;
  right: 8px;
  z-index: 10;
  cursor: pointer;
  background-color: red;
  border-radius: 100%;
  width: 25px;
  height: 25px;
  display: flex;
  align-items: center;
  justify-content: center;

  @media (pointer: coarse) {
    top: 10px;
    right: 10px;
    width: 28px;
    height: 28px;
  }

  @media print {
    display: none !important;
  }
`;

const PrintButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  color: #fff;
  background-color: #000;
  width: 25px;
  margin-top: 15px;
  margin-right: 15px;
  height: 25px;
  border-radius: 100%;
  cursor: pointer;
  touch-action: manipulation;

  @media print {
    display: none !important;
  }
`;

const PrintContent = styled.div`
  background-color: #f6f6f6;
  border-radius: 13px;
  border: 1px solid #000;
  padding: 30px 20px 20px 20px;
  max-width: 90vw;
  min-height: min(70vh, 640px);
  position: relative;

  @media (max-width: 1024px) {
    min-height: min(48vh, 440px);
    padding: 22px 18px 18px 18px;
  }

  @media (pointer: coarse) and (min-width: 744px) {
    min-height: min(580px, 78vh);
    padding: 24px 18px 20px 18px;
  }

  @media (pointer: coarse) and (max-width: 743px) {
    min-height: min(340px, 64vh);
    padding: 20px 16px 16px 16px;
  }

  @media print {
    & svg text {
      opacity: 1 !important;
      visibility: visible !important;
      display: block !important;
    }
    & text {
      opacity: 1 !important;
      visibility: visible !important;
    }
    position: relative !important;
    width: 100% !important;
    max-width: 100% !important;
    margin: 0 !important;
    padding: 20px !important;
    background-color: white !important;
    border: 1px solid #000 !important;
    border-radius: 0 !important;
    page-break-inside: avoid;
    break-inside: avoid;
    overflow: visible !important;

    & > div {
      page-break-inside: avoid;
      break-inside: avoid;
      overflow: visible !important;
    }

    & .recharts-tooltip-cursor,
    & .recharts-tooltip-cursor-fill,
    & .recharts-active-shape,
    & .recharts-reference-line,
    & .recharts-tooltip-wrapper,
    & rect[fill="rgba(0,0,0,0.06)"],
    & rect[fill="rgba(0,0,0,0)"] {
      display: none !important;
      visibility: hidden !important;
      opacity: 0 !important;
    }

    & svg {
      shape-rendering: crispEdges;
      -webkit-print-color-adjust: exact;
      print-color-adjust: exact;
    }

    & .recharts-bar-rectangle {
      fill-opacity: 1 !important;
      stroke: none !important;
    }

    @page {
      size: letter;
      margin: 15mm;
    }
  }
`;

const ChartWrap = styled.div`
  width: 100%;
  height: auto;
  min-height: 220px;
  max-height: 280px;
  aspect-ratio: 4 / 3;

  @media (max-width: 900px) {
    aspect-ratio: 3 / 4;
    min-height: 240px;
    max-height: 300px;
  }

  @media (max-width: 600px) {
    aspect-ratio: 1 / 1.1;
    min-height: 220px;
    max-height: 280px;
  }

  @media (pointer: coarse) and (min-width: 744px) {
    min-height: 280px;
    max-height: 360px;
    aspect-ratio: 4 / 3;
  }

  @media (pointer: coarse) and (max-width: 743px) {
    min-height: 200px;
    max-height: 260px;
    aspect-ratio: 4 / 3;
  }

  @media print {
    & svg text {
      opacity: 1 !important;
      visibility: visible !important;
      display: block !important;
    }
    & .recharts-tooltip-cursor,
    & .recharts-tooltip-cursor-fill,
    & .recharts-active-shape,
    & .recharts-reference-line,
    & .recharts-tooltip-wrapper {
      display: none !important;
      visibility: hidden !important;
      opacity: 0 !important;
    }

    & svg {
      shape-rendering: crispEdges;
      -webkit-print-color-adjust: exact;
      print-color-adjust: exact;
    }

    & .recharts-bar-rectangle {
      fill-opacity: 1 !important;
      stroke: none !important;
    }

    & rect[fill="rgba(0,0,0,0.06)"],
    & rect[fill="rgba(0,0,0,0)"] {
      display: none !important;
      visibility: hidden !important;
    }

    & text {
      -webkit-print-color-adjust: exact;
      print-color-adjust: exact;
      opacity: 1 !important;
      visibility: visible !important;
    }
  }
`;

const DomainsPerformanceChart = React.memo(({ data, color }) => {
    return (
        <ChartWrap className="print-pdf-chart">
            <ResponsiveContainer width="100%" height="100%">
            <BarChart
                data={data}
                layout="vertical"
                margin={{ top: 24, right: 12, bottom: 8, left: 12 }}
                barSize={100}
                maxBarSize={120}
                barCategoryGap={12}
                barGap={4}
                isAnimationActive={false}
            >
                <CartesianGrid strokeDasharray="3 3" vertical horizontal={false} />
                <Legend
                    verticalAlign="top"
                    align="center"
                    iconType="circle"
                    iconSize={10}
                    wrapperStyle={{ paddingBottom: 8 }}
                />
                <XAxis
                    type="number"
                    dataKey="value"
                    tick={{ fill: "#61677E", fontSize: 12 }}
                    tickMargin={6}
                    axisLine={false}
                    tickLine={false}
                />
                <YAxis
                    type="category"
                    dataKey="name"
                    width={90}
                    tickMargin={28}
                    tick={{ fill: "#61677E", fontSize: 12 }}
                    axisLine={false}
                    tickLine={false}
                />
                <Tooltip cursor={{ fill: "rgba(0,0,0,0.06)" }} />
                <Bar
                    name="Domains"
                    dataKey="value"
                    fill={color || "#fb742b"}
                    barSize={90}
                    radius={[0, 10, 10, 0]}
                    fillOpacity={1}
                    activeBar={{ style: { fillOpacity: 0.8 } }}
                >
                    <LabelList
                        dataKey="value"
                        position="insideRight"
                        formatter={(value) => `${value}%`}
                        fill="#000"
                        fontSize={12}
                        fontWeight={600}
                        stroke="#000"
                        strokeWidth={0.3}
                    />
                </Bar>
            </BarChart>
            </ResponsiveContainer>
        </ChartWrap>
    );
}, (prevProps, nextProps) => {
    if (!prevProps.data || !nextProps.data) return prevProps.data === nextProps.data;
    if (prevProps.data.length !== nextProps.data.length) return false;
    if (prevProps.color !== nextProps.color) return false;
    return prevProps.data.every((item, index) => {
        const nextItem = nextProps.data[index];
        return item.name === nextItem.name && item.value === nextItem.value;
    });
});

DomainsPerformanceChart.displayName = 'DomainsPerformanceChart';

const ExamButton = styled.button`
     background-color:${COLOR.blueishdeep};
     width:120px;
     height:30px;
     border-radius:5px;
     margin-left:5px;
     margin-right:5px;
     border: 1px solid ${p => p.active ? "#f6ebeb" : "transparent"};
     cursor: pointer;
     box-sizing: border-box;
     box-shadow:${p => p.active ? "2px 2px 2px rgb(35 53 89 / 19%), -2px -2px 2px rgb(35 53 89 / 19%)" : "none"};
     color:rgb(255,255,255);

     @media screen and (max-width: 496px){
        width: 45%;
        flex: 1 auto;
        margin-left:0px;
        margin-top:3px;
        margin-bottom:3px;
     }
    @media screen and (max-width: 372px){
        width: 100%;
    }
}
`;

const PaddedBtn = styled.button`
    background-color: transparent;
    border: none;
    cursor: pointer;
    font-size: 12px;
    font-weight: 600;
    outline: none;
    padding: 8px;
    text-align: left;
    width: 100%;
`;

const sortname = (a, b) => {
    const nameA = get(a, "lastName", "").toLowerCase()?.replace(/\s/g, '');
    const nameB = get(b, "lastName", "").toLowerCase()?.replace(/\s/g, '');;
    if (nameA < nameB) { return -1 }
    else if (nameA > nameB) { return 1 }
    else { return 0 }
}

const StudentStatusSelector = styled.div`
    min-height: 20px;
    min-width: 120px;
    border-radius: 20px;
    background: #4a90e2;
    cursor: pointer;
    display: flex;
    flex-direction: row;
    color: #fff;
    align-items: center;
    justify-content: space-between;
    text-transform: capitalize;
    overflow: hidden;
    text-overflow: ellipsis;
    padding: 3px 7px;
    font-size: 12px;
    margin: 5px 16px 5px 5px;
    transition: all 0.3s ease;
    &:hover {
        background: #357abd;
        transform: translateY(-1px);
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
    }
`;

const ReportButton = styled.div`
    cursor: pointer;
    border-right: 1px solid #e6e6e6;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 60px;
    height: 32px;
`;

const ExamTable = ({
    dataLoading,
    currentUser: propCurrentUser,
    setExamData,
    examType,
    onClose,
    exams,
    onExamTabClick,
    currentClass: propCurrentClass,
    initialSelectedClassId,
}) => {
    const dispatch = useDispatch();
    const selectorCurrentUser = useCurrentUser();
    const selectorCurrentClass = useCurrentClass();
    const currentUser = propCurrentUser || selectorCurrentUser;
    const currentClass = propCurrentClass || selectorCurrentClass;
    const { Option } = Select;
    const [filteredStudent, setFilteredStudent] = useState([])
    const [activeSession, setActiveSession] = useState(upcomming_year);
    const [apiData, setApiData] = useState({ question_length: [], grades: [], assigned_activities_count: 0 })
    const [apiDataLoading, setApiDataLoading] = useState(false)
    const [apiDataCombine, setApiDataCombine] = useState({ question_length: [], grades: [] })
    const [listStudentUser, setListStudentUser] = useState([])
    const [examSchool, setExamSchool] = useState(EXAM_SCHOOLS[0])
    const [activeInactive, setActiveInactive] = useState('active')
    const [studentSearch, setStudentSearch] = useState('');
    const [modal, setModal] = useState(false);
    const [selectedStudent, setSelectedStudent] = useState(null);
    const [selectedClassId, setSelectedClassId] = useState(null);
    const [studentData, setStudentData] = useState(null);
    const [loading, setLoading] = useState(false);
    const [openFlagModal, setOpenFlagModal] = useState(false);
    const printRef = useRef();
    const [printLoader, setPrintLoader] = useState(false);
    const isTablate = useTabletDetection();
    const isMobile = useMobileDetect() && !isTablate;
    const showAlert = useAlert();
    const navigate = useNavigate();
    const isCombined = examType === "combined"
    const classUsers = useClassUsers();
    const usersByClass = useUsersByClass();

    const effectiveSession = useMemo(() => {
        if (!exams?.length) return activeSession;
        const grp = groupBy(exams, "session");
        if (activeSession && grp[activeSession]) return activeSession;
        if (grp[downcomming_year]) return downcomming_year;
        return activeSession;
    }, [exams, activeSession]);

    const fetchExamData = useCallback(async (sessionOverride, overrideClassId = null) => {
        const sessionToUse = sessionOverride ?? activeSession;
        if (!currentClass?.id || !currentUser?.id || !currentUser?.orgId || !sessionToUse) return;

        setApiDataLoading(true);
        try {
            if (isCombined) {
                const examPromises = ['1', '2', '3'].map(e_type =>
                    dispatch(handleListExamDataByConfig({
                        session: sessionToUse,
                        exam_type: e_type,
                        school_level: EXAM_SCHOOLS_ABBR[EXAM_SCHOOLS.indexOf(examSchool)],
                        class_id: overrideClassId ? overrideClassId : selectedClassId ? selectedClassId : currentClass.id,
                        teacher_id: currentUser.id,
                        id: currentUser.orgId,
                        school_id: currentUser.orgId
                    }))
                );
                const dataExams = await Promise.all(examPromises);
                if (dataExams[0]?.question_length) {
                    const question_length = [];
                    dataExams[0].question_length.forEach((_, i) => {
                        question_length.push({
                            exam1: dataExams[0].question_length[i] || '-',
                            exam2: dataExams[1]?.question_length?.[i] || '-',
                            exam3: dataExams[2]?.question_length?.[i] || '-'
                        });
                    });
                    const userMap = new Map();
                    [0, 1, 2].forEach(examIdx => {
                        (dataExams[examIdx]?.grades || []).forEach((grade) => {
                            const userId = grade.user?.id;
                            if (userId) {
                                if (!userMap.has(userId)) {
                                    userMap.set(userId, {
                                        user: grade.user,
                                        submissions: []
                                    });
                                }
                                const userEntry = userMap.get(userId);
                                const subs = grade.submissions || [];
                                const maxLen = Math.max(
                                    userEntry.submissions.length,
                                    subs.length
                                );
                                for (let j = 0; j < maxLen; j++) {
                                    if (!userEntry.submissions[j]) {
                                        userEntry.submissions[j] = { exam1: '-', exam2: '-', exam3: '-' };
                                    }
                                    if (j < subs.length) {
                                        const value = subs[j] || '-';
                                        if (j === 0) {
                                            userEntry.submissions[j][`exam${examIdx + 1}`] = convertPlacementToAbbr(value);
                                        } else {
                                            userEntry.submissions[j][`exam${examIdx + 1}`] = value;
                                        }
                                    }
                                }
                            }
                        });
                    });
                    const combinedGrades = Array.from(userMap.values());
                    setApiDataCombine({ question_length, grades: combinedGrades });
                }
            } else {
                const examTypeNum = examType === 'exam1' ? '1' : examType === 'exam2' ? '2' : examType === 'exam3' ? '3' : '1';
                const data = await dispatch(handleListExamDataByConfig({
                    session: sessionToUse,
                    exam_type: examTypeNum,
                    school_level: EXAM_SCHOOLS_ABBR[EXAM_SCHOOLS.indexOf(examSchool)],
                    class_id: overrideClassId ? overrideClassId : selectedClassId ? selectedClassId : currentClass.id,
                    teacher_id: currentUser.id,
                    id: currentUser.orgId,
                    school_id: currentUser.orgId
                }));
                if (data && data.question_length) {
                    const qLength = [...(data.question_length || [])];
                    setApiData({
                        question_length: qLength,
                        grades: data.grades || [],
                        assigned_activities_count: data.assigned_activities_count || 0
                    });
                }
            }
        } catch (error) {
            Sentry.captureException(`Error fetching exam data: ${error}`);
        } finally {
            setApiDataLoading(false);
        }
    }, [currentClass?.id, currentUser?.id, currentUser?.orgId, examSchool, examType, isCombined, selectedClassId, activeSession, dispatch]);

    const selectedRosterUsers = useMemo(() => {
        const targetClassId = selectedClassId || currentClass?.id;
        return resolveGradebookRosterRaw(targetClassId, currentClass, classUsers, usersByClass);
    }, [selectedClassId, currentClass, classUsers, usersByClass]);

    const examGradesStatusFiltered = useMemo(() => {
        const base = isCombined ? (apiDataCombine.grades || []) : (apiData.grades || []);
        if (activeInactive === 'all') {
            return base;
        }
        return base.filter((g) => {
            const raw = g.user || g;
            const u = mergeExamUserWithClassRoster(raw, selectedRosterUsers);
            return studentMatchesGradebookActiveFilter(u, activeInactive, false);
        });
    }, [apiData, apiDataCombine, isCombined, activeInactive, selectedRosterUsers]);

    const applyStudentListFilters = useCallback(() => {
        const statusFiltered = examGradesStatusFiltered;
        const search = studentSearch?.toLowerCase()?.trim() || '';
        let next = statusFiltered;
        if (search) {
            next = filter(statusFiltered, (grade) => {
                const raw = grade.user || {};
                const u = mergeExamUserWithClassRoster(raw, classUsers);
                const firstName = u.firstName?.toLowerCase()?.trim() || '';
                if (search.length === 1) {
                    return firstName.charAt(0) === search;
                }
                return firstName.includes(search);
            });
        }
        setFilteredStudent(next);
        const users = uniqBy(
            next.map((g) => g.user).filter(Boolean).sort(sortname),
            'username'
        );
        setListStudentUser(users);
    }, [examGradesStatusFiltered, studentSearch, classUsers]);

    useEffect(() => {
        applyStudentListFilters();
    }, [applyStudentListFilters]);

    useEffect(() => {
        fetchExamData(effectiveSession);
        if (effectiveSession !== activeSession) {
            setActiveSession(effectiveSession);
        }
    }, [effectiveSession, examType, examSchool, currentClass?.id, currentUser?.id, currentUser?.orgId, isCombined, fetchExamData])

    const handleRefreshExamData = useCallback(() => {
        fetchExamData(effectiveSession);
    }, [fetchExamData, effectiveSession]);

    useEffect(() => {
        if (initialSelectedClassId) {
            setSelectedClassId(initialSelectedClassId);
            return;
        }
        if (currentClass?.id) {
            setSelectedClassId(currentClass?.id);
        }
    }, [initialSelectedClassId, currentClass?.id]);
    const isExamGradeModalRowPayload = (value) => {
        if (value == null || typeof value !== 'object') return false;
        if ('nativeEvent' in value && typeof value.preventDefault === 'function') return false;
        return Boolean(value.user || value.id || value.firstName);
    };

    const toggleModal = (student = null) => {
        const row = isExamGradeModalRowPayload(student) ? student : null;
        if (row) {
            const user = row.user || row;
            setSelectedStudent(user);
            setSelectedClassId(user.class_id || user.classId || null);
        }
        setModal(!modal);
        if (modal) {
            setOpenFlagModal(false);
        }
        if (!modal && row) {
            setStudentData(null);
        }
    };

    const handleExamGradeModalClose = (event, reason) => {
        if (reason === 'backdropClick') {
            return;
        }
        toggleModal();
    };

    const openExamFlagLegend = useCallback(() => {
        setOpenFlagModal(true);
    }, []);

    const closeExamFlagLegend = useCallback(() => {
        setOpenFlagModal(false);
    }, []);

    const getPriorityColor = (performance) => {
        if (performance >= 80) return '#078247';
        if (performance >= 60) return '#7b13c3';
        return '#df0d14';
    };

    const getPriorityText = (performance) => {
        if (performance >= 80) return 'On Track';
        if (performance >= 60) return 'Needs Attention';
        return 'Urgent Support Needed';
    };

    const domainsChartData = useMemo(() => {
        if (studentData?.domains && studentData.domains.length > 0) {
            return studentData.domains;
        }
        return domainData;
    }, [studentData?.domains]);

    const examGradeEyeRndDefault = useMemo(() => {
        if (typeof window === 'undefined') return { x: 16, y: 16 };
        const estW = Math.min(900, Math.max(300, window.innerWidth - 48));
        const x = Math.max(8, Math.floor((window.innerWidth - estW) / 2));
        const y = Math.max(8, Math.floor(window.innerHeight * 0.04));
        return { x, y };
    }, [modal, selectedStudent?.id]);

    const examGradeFlagRndDefault = useMemo(() => {
        if (typeof window === 'undefined') return { x: 80, y: 120 };
        const w = window.innerWidth;
        const h = window.innerHeight;
        const x = Math.max(16, Math.min(Math.floor(w * 0.06), w - 280));
        const y = Math.max(72, Math.min(Math.floor(h * 0.14), h - 200));
        return { x, y };
    }, [modal, selectedStudent?.id]);

    const printCall = useReactToPrint({
        contentRef: printRef,
        onBeforeGetContent: async () => {
            return new Promise((resolve) => {
                setPrintLoader(true);
                setTimeout(() => resolve(), 100);
            });
        },
        onBeforePrint: async () => {
            setPrintLoader(true);
        },
        onAfterPrint: async () => {
            setPrintLoader(false);
            removePrintableClass();
        },
        onPrintError: async () => {
            setPrintLoader(false);
            removePrintableClass();
        },
    });

    const handlePrint = () => {
        if (isMobile || isTablate) {
            showAlert("Print is not supported on this device!", "error");
            return;
        }
        setPrintLoader(true);
        addPrintableClass();
        setTimeout(() => {
            printCall();
        }, 100);
    };

    useEffect(() => {
        const loadStudentData = async () => {
            if (!modal || !selectedStudent || !activeSession || !currentUser?.orgId || !examType || examType === 'combined') return;

            const examNumber = examType === 'exam1' ? '1' : examType === 'exam2' ? '2' : examType === 'exam3' ? '3' : null;
            if (!examNumber) return;

            setLoading(true);
            try {
                const res = await dispatch(handleGetStudentSubmissionDetailsProficiency(
                    selectedStudent.id,
                    activeSession,
                    currentUser.orgId,
                    examNumber,
                    selectedClassId,
                    EXAM_SCHOOLS_ABBR[EXAM_SCHOOLS.indexOf(examSchool)]
                ));
                if (res?.success && res?.data) {
                    setStudentData(res.data);
                }
            } catch (error) {
                console.error('Error loading student data:', error);
            } finally {
                setLoading(false);
            }
        };
        loadStudentData();
    }, [modal, selectedStudent, selectedClassId, activeSession, currentUser?.orgId, examType, examSchool, dispatch]);

    useEffect(() => {
        handleSetExamData()
    }, [examSchool, examType, filteredStudent, apiData])



    const getExamGrade = (user, i) => {
        if (!user) {
            const result = ["-", ...(apiData.question_length || [])];
            if (result.length < EXAM_LABELS.length + 1) {
                result.splice(2, 0, "-");
            }
            while (result.length < EXAM_LABELS.length + 1) {
                result.push("-");
            }
            return result;
        } else {
            const gradeData = find(apiData.grades, g => g.user?.id === user.id);
            if (gradeData && gradeData.submissions) {
                const result = ["-", ...gradeData.submissions.slice(1)];
                if (result.length < EXAM_LABELS.length + 1) {
                    result.splice(2, 0, "N\\A");
                }
                while (result.length < EXAM_LABELS.length + 1) {
                    result.push("-");
                }
                return result;
            }
            return Array.from(new Array(EXAM_LABELS.length + 1)).fill("-");
        }
    }
    const getExamGradeCombine = useCallback((user, i) => {
        if (!user) {
            const result = [{ exam1: '', exam2: '', exam3: '' }];
            const qLength = apiDataCombine.question_length || [];
            qLength.forEach((q, idx) => {
                if (!result[idx + 1]) {
                    result[idx + 1] = { exam1: '-', exam2: '-', exam3: '-' };
                }
                result[idx + 1].exam1 = q.exam1 || '-';
                result[idx + 1].exam2 = q.exam2 || '-';
                result[idx + 1].exam3 = q.exam3 || '-';
            });
            while (result.length < EXAM_LABELS.length + 1) {
                result.push({ exam1: '-', exam2: '-', exam3: '-' });
            }
            return result;
        } else {
            const gradeData = find(apiDataCombine.grades, g => g.user?.id === user.id);
            const result = [{ exam1: '', exam2: '', exam3: '' }];
            if (gradeData && gradeData.submissions) {
                const subs1 = gradeData.submissions.exam1 || [];
                const subs2 = gradeData.submissions.exam2 || [];
                const subs3 = gradeData.submissions.exam3 || [];
                const maxLen = Math.max(subs1.length, subs2.length, subs3.length);
                for (let i = 1; i < maxLen; i++) {
                    result.push({
                        exam1: subs1[i] || '-',
                        exam2: subs2[i] || '-',
                        exam3: subs3[i] || '-'
                    });
                }
            }
            while (result.length < EXAM_LABELS.length + 1) {
                result.push({ exam1: '-', exam2: '-', exam3: '-' });
            }
            return result;
        }
    }, [apiDataCombine, examSchool])
    const getPlacement = (user) => {
        if (!user) return "";
        const gradeData = find(apiData.grades, g => g.user?.id === user.id);
        if (gradeData && gradeData.submissions && gradeData.submissions.length > 0) {
            return gradeData.submissions[0] || "NOT STARTED";
        }
        return "NOT STARTED";
    }
    const getPlacementCombine = (user) => {
        const res = {
            exam1: '',
            exam2: '',
            exam3: ''
        }
        if (!user) return res;
        const gradeData = find(apiDataCombine.grades, g => g.user?.id === user.id);
        if (gradeData && gradeData.submissions) {
            const subs1 = gradeData.submissions.exam1 || [];
            const subs2 = gradeData.submissions.exam2 || [];
            const subs3 = gradeData.submissions.exam3 || [];
            res.exam1 = subs1[0] || "NS";
            res.exam2 = subs2[0] || "NS";
            res.exam3 = subs3[0] || "NS";
        } else {
            res.exam1 = "NS";
            res.exam2 = "NS";
            res.exam3 = "NS";
        }
        return res;
    }
    const getPlacemEntColor = (v) => {
        if (v == ACIFL_LEVEL[2] || v == ACIFL_LEVEL_ABBR[2]) {
            return PLACEMNETCOLOR[0]
        } else if (v == ACIFL_LEVEL[3] || v == ACIFL_LEVEL_ABBR[3]) {
            return PLACEMNETCOLOR[1]
        } else if (v == ACIFL_LEVEL[4] || v == ACIFL_LEVEL_ABBR[4]) {
            return PLACEMNETCOLOR[2]
        } else if (v == ACIFL_LEVEL[5] || v == ACIFL_LEVEL_ABBR[5]) {
            return PLACEMNETCOLOR[3]
        } else if (v == ACIFL_LEVEL[6] || v == ACIFL_LEVEL_ABBR[6]) {
            return PLACEMNETCOLOR[4]
        } else if (v == ACIFL_LEVEL[7] || v == ACIFL_LEVEL_ABBR[7]) {
            return PLACEMNETCOLOR[5]
        } else if (v == ACIFL_LEVEL[8] || v == ACIFL_LEVEL_ABBR[8]) {
            return PLACEMNETCOLOR[7]
        } else if (v == 'NOT FINISHED' || v == 'NF') {
            return COLOR.yellow
        }
        else {
            return COLOR.gray100;
        }
    }

    const renderExamTableEmpty = () => {
        const hasSearch = Boolean(studentSearch?.trim());
        const baseCount = examGradesStatusFiltered?.length || 0;
        const message =
            hasSearch && baseCount > 0
                ? 'No students found.'
                : 'No exam grade data to display.';
        return (
            <ExamTableEmptyState role="status">
                {message}
            </ExamTableEmptyState>
        );
    };

    const ViewGradeTable = ({ filteredusers_response, question_length, toggleModal, examType }) => {
        const [page, setPage] = React.useState(0);
        const [rowsPerPage, setRowsPerPage] = useState(50);
        const handleChangePage = (event, newPage) => {
            setPage(newPage);
        };
        useEffect(() => {
            setPage(0)
        }, [filteredusers_response])
        const handleChangeRowsPerPage = (event) => {
            setRowsPerPage(parseInt(event.target.value, 10));
            setPage(0);
        }

        const checkMark = (submissions) => {
            if (!submissions.includes("-")) {
                return <TootipWrapper hasToolTip label={`Completed`}>
                    <Check style={{ backgroundColor: COLOR.greentrue, color: COLOR.white, fontSize: 12, borderRadius: "50%" }} />
                </TootipWrapper>
            } else if (containsNumber(submissions)) {
                return <TootipWrapper hasToolTip label={`Not finished`}>
                    <Check style={{ backgroundColor: COLOR.orange100, color: COLOR.white, fontSize: 12, borderRadius: "50%" }} />
                </TootipWrapper>
            } else {
                return null;
            }
        }
        return (<SentryWrap>
            <ExamGradeBoday style={{ display: "flex", flexDirection: "column", marginTop: -3 }}>
                <div style={{ display: "flex", flexDirection: "row" }}>
                    <ExamTableSection1>
                        <StudentNameTable>
                            <QuestionTab>Questions per section:</QuestionTab>
                        </StudentNameTable>
                        <StudentNameTable>
                            <QuestionTab>Max points possible:</QuestionTab>
                        </StudentNameTable>
                    </ExamTableSection1>
                    <ExamTableSection2>
                        <ExamGradeTable borderd>
                            <ExamRow>
                                {(question_length || []).slice(0, MAX_TABLE_COLUMNS).map((k, i) => {
                                    let _width = i == 0 ? 140 : getWidth(i - 1);
                                    return (
                                        <TableItem key={i + "q_len"} style={{ width: _width }}>{k}</TableItem>
                                    )
                                })}
                            </ExamRow>
                            <ExamRow className={styles.examRowSecond}>
                                {SECTION_MAX_POINTS.slice(0, MAX_TABLE_COLUMNS).map((k, i) => {
                                    let _width = i == 0 ? 140 : getWidth(i - 1);
                                    return (
                                        <TableItem key={i + "max"} style={{ width: _width }}>{i == 0 ? "" : k}</TableItem>
                                    )
                                })}
                            </ExamRow>
                        </ExamGradeTable>
                    </ExamTableSection2>
                </div>
                <FlatList
                    list={filteredusers_response.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)}
                    renderItem={({ user, submissions }, i) => (
                        <div
                            style={{ display: "flex", flexDirection: "row" }}
                            className={i % 2 === 0 ? styles.examCellEven : styles.examCellOdd}
                            key={i + "res"}
                        >
                            
                            <ExamTableSection1>
                                <StudentNameTable>
                                    <TootipWrapper hasToolTip label={`${user.firstName} , ${user.lastName}`}>
                                        <StudentName>
                                            <StudentNameText>{user.firstName} , {user.lastName}</StudentNameText>
                                            <RemoveRedEyeIcon sx={{ color: 'black', cursor: 'pointer' }} onClick={() => toggleModal(user)} />
                                        </StudentName>
                                    </TootipWrapper>
                                </StudentNameTable>
                            </ExamTableSection1>

                            <ExamTableSection2>
                                <ExamGradeTable borderd>
                                    <ExamRow>
                                        {map((submissions || []).slice(0, MAX_TABLE_COLUMNS), (k, ind) => {
                                            let _width = ind == 0 ? 140 : getWidth(ind - 1);
                                            let displayValue = k;
                                            if (typeof k === 'object' && k !== null) {
                                                const examKey = examType === 'exam1' ? 'exam1' : examType === 'exam2' ? 'exam2' : examType === 'exam3' ? 'exam3' : 'exam1';
                                                displayValue = k[examKey] || k.exam1 || k.exam2 || k.exam3 || '-';
                                            }
                                            return (
                                                <TableItem style={{ width: _width }} key={ind + "plac"}>
                                                    {ind == 0 ? (
                                                        <PlacementText textColor={getPlacemEntColor(displayValue)}>
                                                            {displayValue} {checkMark(submissions)}
                                                        </PlacementText>
                                                    ) : (
                                                        displayValue
                                                    )}
                                                </TableItem>
                                            )
                                        })}
                                    </ExamRow>
                                </ExamGradeTable>
                            </ExamTableSection2>
                            
                        </div>
                    )}
                    renderWhenEmpty={renderExamTableEmpty}
                />
            </ExamGradeBoday>
            <TablePagination
                className={styles.examTablePagination}
                count={filteredusers_response.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                rowsPerPageOptions={[50, 100, 150, 200, 300, 400, 500]}
                backIconButtonProps={{
                    color: "secondary"
                }}
                nextIconButtonProps={{ color: "secondary" }}
            />
        </SentryWrap>)
    }

    const ViewGradeTableCombine = ({ filteredusers_response, question_length, toggleModal }) => {
        const [page, setPage] = React.useState(0);
        const [rowsPerPage, setRowsPerPage] = useState(100);
        const handleChangePage = (event, newPage) => {
            setPage(newPage);
        };
        const handleChangeRowsPerPage = (event) => {
            setRowsPerPage(parseInt(event.target.value, 10));
            setPage(0);
        }
        useEffect(() => {
            setPage(0)
        }, [filteredusers_response])
        return (<>
            <ExamGradeBoday style={{ display: "flex", flexDirection: "column", marginTop: -3 }}>
                <div style={{ display: "flex", flexDirection: "row" }}>
                    <ExamTableSection1>
                        <StudentNameTable>
                            <QuestionTab style={{ backgroundColor: COLOR.indigo200, justifyContent: 'center' }}>Exams</QuestionTab>
                        </StudentNameTable>
                        <StudentNameTable>
                            <QuestionTab>Questions per section:</QuestionTab>
                        </StudentNameTable>
                    </ExamTableSection1>
                    <ExamTableSection2>
                        <ExamGradeTable borderd>
                            <ExamRow>
                                {map(['', ...EXAM_LABELS], (k, i) => {
                                    let _width = i == 0 ? 140 : getWidth(i - 1);
                                    return (<div key={k + i} style={{ backgroundColor: COLOR.indigo400, color: "#fff", width: _width }}>
                                        <TableItem style={{ width: _width / 3, fontSize: '12px', fontWeight: '600' }}>E1</TableItem>
                                        <TableItem style={{ width: _width / 3, fontSize: '12px', fontWeight: '600' }}>E2</TableItem>
                                        <TableItem style={{ width: _width / 3, fontSize: '12px', fontWeight: '600' }}>E3</TableItem>
                                    </div>)
                                })}
                            </ExamRow>
                            <ExamRow>
                                {(question_length || []).slice(0, MAX_TABLE_COLUMNS).map(({ exam1, exam2, exam3 }, i) => {
                                    let _width = i == 0 ? 140 : getWidth(i - 1);
                                    return (
                                        <div key={exam1 + i} style={{ width: _width, backgroundColor: i % 2 != 0 ? "rgb(242,248,254)" : "transparent" }}>
                                            <TableItem style={{ width: _width / 3 }}>
                                                {i == 0 ? "" : exam1}
                                            </TableItem>
                                            <TableItem style={{ width: _width / 3 }}>
                                                {i == 0 ? "" : exam2}
                                            </TableItem>
                                            <TableItem style={{ width: _width / 3 }}>
                                                {i == 0 ? "" : exam3}
                                            </TableItem>
                                        </div>
                                    )
                                })}
                            </ExamRow>
                        </ExamGradeTable>
                    </ExamTableSection2>
                </div>
                <FlatList
                    list={filteredusers_response.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)}
                    renderItem={(item, ind) => {
                        const { user, submissions } = item;
                        return (
                            <div style={{ display: "flex", flexDirection: "row" }} key={ind + "res"}>
                                <ExamTableSection1>
                                    <StudentNameTable>
                                        <StudentName>
                                            <StudentNameText>{user?.firstName} , {user?.lastName}</StudentNameText>
                                            <RemoveRedEyeIcon sx={{ color: 'black', cursor: 'pointer' }} onClick={() => toggleModal(item)} />
                                        </StudentName>
                                    </StudentNameTable>
                                </ExamTableSection1>
                                <ExamTableSection2>
                                    <ExamGradeTable borderd>
                                        <ExamRow>
                                            {map((submissions || []).slice(0, MAX_TABLE_COLUMNS), (sub, ind) => {
                                                let _width = ind == 0 ? 140 : getWidth(ind - 1);
                                                const exam1 = sub?.exam1 || '-';
                                                const exam2 = sub?.exam2 || '-';
                                                const exam3 = sub?.exam3 || '-';
                                                return (
                                                    <div key={ind} style={{ width: _width, backgroundColor: ind % 2 != 0 ? "rgb(242,248,254)" : "transparent" }}>
                                                        {ind == 0 ? (
                                                            <div>
                                                                <TableItem style={{ width: _width / 3 }}>
                                                                    <PlacementText textColor={getPlacemEntColor(exam1)}>
                                                                        {exam1}
                                                                    </PlacementText>
                                                                </TableItem>
                                                                <TableItem style={{ width: _width / 3 }}>
                                                                    <PlacementText textColor={getPlacemEntColor(exam2)}>
                                                                        {exam2}
                                                                    </PlacementText>
                                                                </TableItem>
                                                                <TableItem style={{ width: _width / 3 }}>
                                                                    <PlacementText textColor={getPlacemEntColor(exam3)}>
                                                                        {exam3}
                                                                    </PlacementText>
                                                                </TableItem>
                                                            </div>
                                                        ) : (
                                                            <div>
                                                                <TableItem style={{ width: _width / 3 }}>
                                                                    {exam1}
                                                                </TableItem>
                                                                <TableItem style={{ width: _width / 3 }}>
                                                                    {exam2}
                                                                </TableItem>
                                                                <TableItem style={{ width: _width / 3 }}>
                                                                    {exam3}
                                                                </TableItem>
                                                            </div>
                                                        )}
                                                    </div>
                                                )
                                            })}
                                        </ExamRow>
                                    </ExamGradeTable>
                                </ExamTableSection2>
                            </div>
                        )
                    }}
                    renderWhenEmpty={renderExamTableEmpty}
                />
            </ExamGradeBoday>
            <TablePagination
                className={styles.examTablePagination}
                count={filteredusers_response.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                rowsPerPageOptions={[50, 100, 150, 200, 300, 400, 500]}
                backIconButtonProps={{
                    color: "secondary"
                }}
                nextIconButtonProps={{ color: "secondary" }}
            />
        </>)
    }
    const filterStudent = (e) => {
        setStudentSearch(e.target.value || '');
    };

    const activeInactiveNav = useCallback(() => {
        return {
            items: [
                { key: 'all', label: 'All', onClick: () => setActiveInactive('all') },
                { key: 'active', label: 'Active', onClick: () => setActiveInactive('active') },
                { key: 'inactive', label: 'Inactive', onClick: () => setActiveInactive('inactive') },
            ],
        };
    }, [activeInactive]);
    const getAciflPlacementChartConfig = (type) => {
        const normalizePlacement = (value) => (value || '').toString().trim().toUpperCase();
        const isFallbackType = type == ACIFL_LEVEL[ACIFL_LEVEL.length - 1];
        const placementIndex = ACIFL_LEVEL.findIndex(level => normalizePlacement(level) === normalizePlacement(type));
        const placementAbbr = placementIndex !== -1 ? ACIFL_LEVEL_ABBR[placementIndex] : null;
        const dt = {};
        const getCombinedPlacements = () => {
            const examKeys = ['exam1', 'exam2', 'exam3'];
            return (examGradesStatusFiltered || []).flatMap((grade) => {
                return examKeys.map((key) => grade?.submissions?.[0]?.[key] || 'NOT STARTED');
            });
        };
        const combinedPlacements = isCombined ? getCombinedPlacements() : [];
        const totalStudent = isCombined ? combinedPlacements.length : (examGradesStatusFiltered?.length || 0);
        let per = 0;

        if (isFallbackType) {
            let sub = 0;
            if (isCombined) {
                combinedPlacements.forEach((placement) => {
                    const normalizedPlacement = normalizePlacement(placement);
                    if (normalizedPlacement && normalizedPlacement !== 'NOT STARTED' && normalizedPlacement !== 'NOT ASSIGNED' && normalizedPlacement !== '-' && normalizedPlacement !== 'NS' && normalizedPlacement !== 'NA') {
                        sub++;
                    }
                });
            } else {
                const grades = examGradesStatusFiltered || [];
                grades.forEach(g => {
                    const placement = g.submissions?.[0] || '';
                    const normalizedPlacement = normalizePlacement(placement);
                    if (normalizedPlacement && normalizedPlacement !== 'NOT STARTED' && normalizedPlacement !== 'NOT ASSIGNED' && normalizedPlacement !== '-' && normalizedPlacement !== 'NS' && normalizedPlacement !== 'NA') {
                        sub++;
                    }
                });
            }
            per = totalStudent - sub > 0 ? (((totalStudent - sub) / totalStudent) * 100).toFixed(0) : 0;
        } else {
            if (isCombined) {
                combinedPlacements.forEach((placementValue) => {
                    const normalizedPlacement = normalizePlacement(placementValue);
                    if (dt[normalizedPlacement]) {
                        dt[normalizedPlacement] = dt[normalizedPlacement] + 1;
                    } else {
                        dt[normalizedPlacement] = 1;
                    }
                });
            } else {
                const grades = examGradesStatusFiltered || [];
                grades.forEach(g => {
                    const placementValue = g.submissions?.[0] || 'NOT STARTED';
                    const normalizedPlacement = normalizePlacement(placementValue);
                    if (dt[normalizedPlacement]) {
                        dt[normalizedPlacement] = dt[normalizedPlacement] + 1;
                    } else {
                        dt[normalizedPlacement] = 1;
                    }
                });
            }
            const normalizedType = normalizePlacement(type);
            const normalizedTypeAbbr = normalizePlacement(placementAbbr);
            const typeCount = (dt[normalizedType] || 0) + (normalizedTypeAbbr ? (dt[normalizedTypeAbbr] || 0) : 0);
            if (typeCount > 0 && totalStudent > 0) {
                per = ((typeCount / totalStudent) * 100).toFixed(0);
            }
        }

        if (per > 0) {
            const perNum = parseFloat(per);
            return {
                data: [
                    { name: type, value: perNum, fill: type == ACIFL_LEVEL[ACIFL_LEVEL.length - 1] ? "rgb(197,2,91)" : chartColors[0] },
                    { name: "", value: 100 - perNum, fill: chartColors[1] },
                ],
                title: `${per ?? "0"}%`
            };
        }
        return {
            data: [
                { name: type, value: 0, fill: chartColors[0] },
                { name: "", value: 100, fill: chartColors[1] },
            ],
            title: "0%"
        };
    }

    const getChartConfig = (type) => getAciflPlacementChartConfig(type);
    const getWidth = (index) => {
        const minSize = 110
        let txt = ACIFL_LEVEL[index]
        if (!txt) return minSize + 50
        return txt.length * 2 + minSize + 10

    }
    const handleSetExamData = () => {
        try {
            const rowData = new Set()
            const jsondata = {
                name: '',
                username: '',
                placement: ''
            }
            getExamGrade().map((k, i) => {
                if (i == 0) {
                    jsondata.placement = '';
                } else {
                    jsondata[EXAM_LABELS_FULL[i - 1]] = k
                }
            })
            rowData.add(jsondata)
            map(filteredStudent, user => {
                const res = getExamGrade(user);
                const userData = {
                    name: `${user.lastName || ""}, ${user.firstName || ""}`,
                    username: user.username,
                    placement: ''
                }
                map(res, (k, ind) => {
                    if (ind == 0) {
                        let v = getPlacement(user, res)
                        userData.placement = v;
                    } else {
                        userData[EXAM_LABELS_FULL[ind - 1]] = k;
                    }
                    rowData.add(userData)
                })
            })
            const extraData = {}
            const dt = {};
            map(listStudentUser, u => {
                const placement = getPlacement(u)
                if (dt[placement]) {
                    dt[placement] = dt[placement] + 1
                } else {
                    dt[placement] = 1
                }
            })
            const totalStudent = listStudentUser.length;
            map(ACIFL_LEVEL, (k, i) => {
                let per = 0;
                if (dt[k]) {
                    let t = dt[k];
                    per = ((t / totalStudent) * 100).toFixed(0)
                }
                if (i == ACIFL_LEVEL.length - 1) {
                    let sub = 0;
                    apiData.grades?.forEach(g => {
                        if (g.submissions && g.submissions.length > 0 && g.submissions[0] !== 'NOT STARTED' && g.submissions[0] !== 'NOT ASSIGNED') {
                            sub++;
                        }
                    });
                    per = totalStudent - sub > 0 ? (((totalStudent - sub) / totalStudent) * 100).toFixed(0) : 0
                }
                extraData[k] = `${per}%`
            })
            const finalData = { data: Array.from(rowData), firstRow: extraData }
            setExamData(finalData)
        } catch (error) {
            Sentry.captureException(`521 Error in handleSetExamData: ${error}`);
            console.log(error, "error in exam gradebook downolad")
        }
    }

    const generateXLSFormatForCombinedExam = async () => {
        try {
            const questionsRow = [
                'Questions per section:',
                '',
                '',
                '',
                '',
                '',
                '',
                '',
            ];

            EXAM_LABELS_FULL.forEach((label, i) => {
                const questionLengths = apiDataCombine.question_length?.[i + 1] || {};
                questionsRow.push(questionLengths.exam1 || '-');
                questionsRow.push(questionLengths.exam2 || '-');
                questionsRow.push(questionLengths.exam3 || '-');
            });

            const maxPointsRow = [
                'Max points possible:',
                '',
                '',
                '',
                '',
                '',
                '',
                '',
            ];

            EXAM_LABELS_FULL.forEach((label, i) => {
                maxPointsRow.push(SECTION_MAX_POINTS[i + 1] || '');
                maxPointsRow.push(SECTION_MAX_POINTS[i + 1] || '');
                maxPointsRow.push(SECTION_MAX_POINTS[i + 1] || '');
            });

            const firstHeaderRow = [
                'Name',
                'Username',
                'Student Id',
                'Teacher Name',
                'School Name',
                'Exam 1',
                'Exam 2',
                'Exam 3',
            ];

            EXAM_LABELS_FULL.forEach((label, i) => {
                firstHeaderRow.push(label);
                firstHeaderRow.push('');
                firstHeaderRow.push('');
            });

            const secondHeaderRow = [
                '',
                '',
                '',
                '',
                '',
                'Placement',
                'Placement',
                'Placement',
            ];

            EXAM_LABELS_FULL.forEach(() => {
                secondHeaderRow.push('Exam 1');
                secondHeaderRow.push('Exam 2');
                secondHeaderRow.push('Exam 3');
            });

            const dataRows = [];
            filteredStudent?.forEach(({ user, submissions }) => {
                const placementData = submissions?.[0] || {};

                const row = [
                    `${user?.lastName || ""}, ${user?.firstName || ""}`,
                    user?.username || '',
                    user?.studentId || '',
                    user?.teacherName || '',
                    user?.schoolName || '',
                    placementData.exam1 || '-',
                    placementData.exam2 || '-',
                    placementData.exam3 || '-',
                ];

                EXAM_LABELS_FULL.forEach((label, i) => {
                    const sectionData = submissions?.[i + 1] || {};
                    row.push(
                        sectionData.exam1 || '-',
                        sectionData.exam2 || '-',
                        sectionData.exam3 || '-'
                    );
                });

                dataRows.push(row);
            });

            const extraData = ACIFL_LEVEL.reduce((acc, type) => {
                acc[type] = getAciflPlacementChartConfig(type).title;
                return acc;
            }, {});

            const exambook = [
                Object.keys(extraData),
                Object.values(extraData),
                [],
                firstHeaderRow,
                questionsRow,
                maxPointsRow,
                secondHeaderRow,
                ...dataRows
            ];

            const ExcelJS = (await import('exceljs')).default;
            const { saveAs } = await import('file-saver');
            const workbook = new ExcelJS.Workbook();
            const worksheet = workbook.addWorksheet('Combined Proficiency');

            const columnCount = secondHeaderRow.length;
            worksheet.columns = Array.from({ length: columnCount }, () => ({ width: 24 }));
            worksheet.addRows(exambook);

            const firstHeaderRowIndex = 3;
            const questionsRowIndex = 4;
            const maxPointsRowIndex = 5;

            const mergeRowCol = (sRow, sCol, eRow, eCol) => {
                worksheet.mergeCells(sRow + 1, sCol + 1, eRow + 1, eCol + 1);
            };

            EXAM_LABELS_FULL.forEach((label, i) => {
                const startCol = 8 + (i * 3);
                mergeRowCol(questionsRowIndex, startCol, questionsRowIndex, startCol + 2);
                mergeRowCol(maxPointsRowIndex, startCol, maxPointsRowIndex, startCol + 2);
                mergeRowCol(firstHeaderRowIndex, startCol, firstHeaderRowIndex, startCol + 2);
            });

            mergeRowCol(firstHeaderRowIndex, 5, firstHeaderRowIndex, 7);

            const zebraEvenFill = 'FFF5F5F5';
            const zebraOddFill = 'FFFFFFFF';
            const headerFontColor = 'FF000000';
            const borderColor = 'FF000000';
            const borderStyle = 'thin';

            const headerStartExcelRow = firstHeaderRowIndex + 1;
            const headerEndExcelRow = firstHeaderRowIndex + 4;

            for (let rowIndex = 1; rowIndex <= exambook.length; rowIndex++) {
                // ✅ simulate vertical padding (py-2)
                if (rowIndex === 1 || rowIndex === 4 || rowIndex === 7) {
                    worksheet.getRow(rowIndex).height = 35; // increase height
                }

                if (rowIndex === 1 || rowIndex === 2) {
                    for (let colIndex = 1; colIndex <= Object.keys(extraData).length; colIndex++) {
                        const cell = worksheet.getCell(rowIndex, colIndex);
                        // ✅ APPLY BORDER TO ALL CELLS
                        cell.border = {
                            top: { style: borderStyle, color: { argb: borderColor } },
                            bottom: { style: borderStyle, color: { argb: borderColor } },
                            left: { style: borderStyle, color: { argb: borderColor } },
                            right: { style: borderStyle, color: { argb: borderColor } }
                        };

                        cell.alignment = {
                            vertical: 'middle',
                            horizontal: 'center',
                            indent: rowIndex === 1 ? 1 : 0 // simulate px spacing
                        };

                        // ✅ BOLD ONLY FIRST ROW
                        if (rowIndex === 1) {
                            cell.font = {
                                bold: true
                            };
                        }


                        // EVEN columns only
                        if (colIndex % 2 === 0) {
                            const cell = worksheet.getCell(rowIndex, colIndex);

                            cell.fill = {
                                type: 'pattern',
                                pattern: 'solid',
                                fgColor: { argb: 'FFF5F5F5' }
                            };
                        }
                    }
                }
                if (rowIndex === 3) continue;

                if (rowIndex >= 4 && rowIndex <= 6) {
                    for (let colIndex = 1; colIndex <= firstHeaderRow.length; colIndex++) {
                        const cell = worksheet.getCell(rowIndex, colIndex);
                        if (rowIndex === 4 || colIndex === 1) {
                            cell.font = {
                                bold: true
                            };
                        }
                        // ✅ APPLY BORDER TO ALL CELLS
                        cell.border = {
                            top: { style: borderStyle, color: { argb: borderColor } },
                            bottom: { style: borderStyle, color: { argb: borderColor } },
                            left: { style: borderStyle, color: { argb: borderColor } },
                            right: { style: borderStyle, color: { argb: borderColor } }
                        };

                        cell.fill = {
                            type: 'pattern',
                            pattern: 'solid',
                            fgColor: { argb: 'FFD9EAD3' } // light grey
                        };

                        cell.alignment = {
                            vertical: 'middle',
                            horizontal: 'center'
                        };
                    }
                }

                if (rowIndex == 7) {
                    for (let colIndex = 1; colIndex <= firstHeaderRow.length; colIndex++) {
                        const cell = worksheet.getCell(rowIndex, colIndex);

                        cell.font = {
                            bold: true
                        };

                        // ✅ APPLY BORDER TO ALL CELLS
                        cell.border = {
                            top: { style: borderStyle, color: { argb: borderColor } },
                            bottom: { style: borderStyle, color: { argb: borderColor } },
                            left: { style: borderStyle, color: { argb: borderColor } },
                            right: { style: borderStyle, color: { argb: borderColor } }
                        };

                        cell.fill = {
                            type: 'pattern',
                            pattern: 'solid',
                            fgColor: { argb: 'FFD9EAF7' } // light grey
                        };

                        cell.alignment = {
                            vertical: 'middle',
                            horizontal: 'center'
                        };
                    }
                }

                const isHeaderRow = rowIndex >= headerStartExcelRow && rowIndex <= headerEndExcelRow;
                const fillColor =
                    rowIndex >= 8
                        ? (rowIndex - 8) % 2 === 0
                            ? zebraOddFill
                            : zebraEvenFill
                        : zebraOddFill;
                const row = worksheet.getRow(rowIndex);

                for (let colIndex = 1; colIndex <= columnCount && rowIndex >= 8; colIndex++) {
                    const cell = row.getCell(colIndex);
                    cell.fill = {
                        type: 'pattern',
                        pattern: 'solid',
                        fgColor: { argb: fillColor }
                    };

                    cell.border = {
                        top: { style: borderStyle, color: { argb: borderColor } },
                        bottom: { style: borderStyle, color: { argb: borderColor } },
                        left: { style: borderStyle, color: { argb: borderColor } },
                        right: { style: borderStyle, color: { argb: borderColor } }
                    };

                    if (isHeaderRow) {
                        cell.font = {
                            bold: true,
                            color: { argb: headerFontColor }
                        };
                        cell.alignment = {
                            vertical: 'middle',
                            horizontal: 'center',
                            wrapText: true
                        };
                    }
                }
            }

            const fileName = `combined_proficiency ${dayjs().format("DD-MM-YY hh:mm:ss")}.xlsx`;
            const buffer = await workbook.xlsx.writeBuffer();
            const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            saveAs(blob, fileName);

            if (currentClass?.id && currentUser?.id) {
                dispatch(handleCreateDownloadList({
                    title: fileName,
                    url: fileName,
                    class_id: selectedClassId ? selectedClassId : currentClass.id,
                    created_by: currentUser.id
                }));
            }
        } catch (error) {
            Sentry.captureException(`Error in combined exam XLS download: ${error}`);
            console.error("Error in combined exam XLS download:", error);
        }
    };

    const generateXLSX = async () => {
        if (isCombined) {
            void generateXLSFormatForCombinedExam();
            return;
        }

        try {
            const questionsRow = [
                'Questions per section:',
                '',
                '',
                '',
                '',
                apiData.question_length?.[0] || '-',
                '',
                '',
                '',
            ];

            EXAM_LABELS_FULL.forEach((label, i) => {
                questionsRow.push(apiData.question_length?.[i + 1] || '-');
                questionsRow.push('');
                questionsRow.push('');
            });

            const maxPointsRow = [
                'Max points possible:',
                '',
                '',
                '',
                '',
                '',
                '',
                '',
                '',
            ];

            EXAM_LABELS_FULL.forEach((label, i) => {
                maxPointsRow.push(SECTION_MAX_POINTS[i + 1] || '');
                maxPointsRow.push('');
                maxPointsRow.push('');
            });

            const firstHeaderRow = [
                'Name',
                'Username',
                'Student Id',
                'Teacher Name',
                'School Name',
                'Placement',
                'Overall',
                '',
                '',
            ];

            EXAM_LABELS_FULL.forEach((label, i) => {
                firstHeaderRow.push(label);
                firstHeaderRow.push('');
                firstHeaderRow.push('');
            });

            const secondHeaderRow = [
                '',
                '',
                '',
                '',
                '',
                '',
                'Overall score',
                'Overall Points possible',
                'Overall Points earned',
            ];

            EXAM_LABELS_FULL.forEach(() => {
                secondHeaderRow.push('overall score');
                secondHeaderRow.push('Overall points possible');
                secondHeaderRow.push('Overall points earned');
            });

            const dataRows = [];
            filteredStudent?.forEach(({ user, submissions, grades_value = [] }) => {
                const overallData = grades_value?.[0] || {};

                const row = [
                    `${user?.lastName || ""}, ${user?.firstName || ""}`,
                    user?.username || '',
                    user?.studentId || '',
                    user?.teacherName || '',
                    user?.schoolName || '',
                    submissions?.[0] || '-',
                    overallData.overall_score !== null && overallData.overall_score !== undefined ? overallData.overall_score : '-',
                    overallData.Overall_Points_possible !== null && overallData.Overall_Points_possible !== undefined ? overallData.Overall_Points_possible : '-',
                    overallData.Overall_Points_earned !== null && overallData.Overall_Points_earned !== undefined ? overallData.Overall_Points_earned : '-',
                ];

                EXAM_LABELS_FULL.forEach((label, i) => {
                    const sectionData = grades_value?.[i + 1] || {};
                    row.push(
                        sectionData.overall_score !== null && sectionData.overall_score !== undefined ? sectionData.overall_score : '-',
                        sectionData.Overall_Points_possible !== null && sectionData.Overall_Points_possible !== undefined ? sectionData.Overall_Points_possible : '-',
                        sectionData.Overall_Points_earned !== null && sectionData.Overall_Points_earned !== undefined ? sectionData.Overall_Points_earned : '-'
                    );
                });

                dataRows.push(row);
            });
            
            const extraData = ACIFL_LEVEL.reduce((acc, type) => {
                acc[type] = getAciflPlacementChartConfig(type).title;
                return acc;
            }, {});

            const ExcelJS = (await import('exceljs')).default;
            const { saveAs } = await import('file-saver');
            const workbook = new ExcelJS.Workbook();
            const worksheet = workbook.addWorksheet('proficiency');

            const exambook = [
                Object.keys(extraData),
                Object.values(extraData),
                [],
                firstHeaderRow,
                questionsRow,
                maxPointsRow,
                secondHeaderRow,
                ...dataRows
            ];

            const columnCount = secondHeaderRow.length;
            worksheet.columns = Array.from({ length: columnCount }, () => ({ width: 24 }));
            worksheet.addRows(exambook);

            const firstHeaderRowIndex = 3;
            const questionsRowIndex = 4;
            const maxPointsRowIndex = 5;

            const mergeRowCol = (sRow, sCol, eRow, eCol) => {
                worksheet.mergeCells(sRow + 1, sCol + 1, eRow + 1, eCol + 1);
            };

            EXAM_LABELS_FULL.forEach((label, i) => {
                const startCol = 9 + (i * 3);
                mergeRowCol(questionsRowIndex, startCol, questionsRowIndex, startCol + 2);
                mergeRowCol(maxPointsRowIndex, startCol, maxPointsRowIndex, startCol + 2);
                mergeRowCol(firstHeaderRowIndex, startCol, firstHeaderRowIndex, startCol + 2);
            });

            mergeRowCol(firstHeaderRowIndex, 6, firstHeaderRowIndex, 8);

            const evenFill = 'FFF5F5F5';
            const oddFill = 'FFFFFFFF';
            const headerFontColor = 'FF000000';
            const borderColor = 'FF000000';
            const borderStyle = 'thin';

            const headerStartExcelRow = firstHeaderRowIndex + 1;
            const headerEndExcelRow = firstHeaderRowIndex + 4;
            const studentHeadlineRowIndex = firstHeaderRowIndex + 1;

            for (let rowIndex = 1; rowIndex <= exambook.length; rowIndex++) {

                // ✅ simulate vertical padding (py-2)
                if (rowIndex === 1 || rowIndex === 4 || rowIndex === 7) {
                    worksheet.getRow(rowIndex).height = 35; // increase height
                }

                if (rowIndex === 1 || rowIndex === 2) {
                    for (let colIndex = 1; colIndex <= Object.keys(extraData).length; colIndex++) {
                        const cell = worksheet.getCell(rowIndex, colIndex);
                        // ✅ APPLY BORDER TO ALL CELLS
                        cell.border = {
                            top: { style: borderStyle, color: { argb: borderColor } },
                            bottom: { style: borderStyle, color: { argb: borderColor } },
                            left: { style: borderStyle, color: { argb: borderColor } },
                            right: { style: borderStyle, color: { argb: borderColor } }
                        };

                        cell.alignment = {
                            vertical: 'middle',
                            horizontal: 'center',
                            indent: rowIndex === 1 ? 1 : 0 // simulate px spacing
                        };

                        // ✅ BOLD ONLY FIRST ROW
                        if (rowIndex === 1) {
                            cell.font = {
                                bold: true
                            };
                        }


                        // EVEN columns only
                        if (colIndex % 2 === 0) {
                            const cell = worksheet.getCell(rowIndex, colIndex);

                            cell.fill = {
                                type: 'pattern',
                                pattern: 'solid',
                                fgColor: { argb: 'FFF5F5F5' }
                            };
                        }
                    }
                }

                if (rowIndex === 3) continue;

                if (rowIndex >= 4 && rowIndex <= 6) {
                    for (let colIndex = 1; colIndex <= firstHeaderRow.length; colIndex++) {
                        const cell = worksheet.getCell(rowIndex, colIndex);
                        if (rowIndex === 4 || colIndex === 1) {
                            cell.font = {
                                bold: true
                            };
                        }
                        // ✅ APPLY BORDER TO ALL CELLS
                        cell.border = {
                            top: { style: borderStyle, color: { argb: borderColor } },
                            bottom: { style: borderStyle, color: { argb: borderColor } },
                            left: { style: borderStyle, color: { argb: borderColor } },
                            right: { style: borderStyle, color: { argb: borderColor } }
                        };

                        cell.fill = {
                            type: 'pattern',
                            pattern: 'solid',
                            fgColor: { argb: 'FFD9EAD3' } // light grey
                        };

                        cell.alignment = {
                            vertical: 'middle',
                            horizontal: 'center'
                        };
                    }
                }

                if (rowIndex == 7) {
                    for (let colIndex = 1; colIndex <= firstHeaderRow.length; colIndex++) {
                        const cell = worksheet.getCell(rowIndex, colIndex);

                        cell.font = {
                            bold: true
                        };

                        // ✅ APPLY BORDER TO ALL CELLS
                        cell.border = {
                            top: { style: borderStyle, color: { argb: borderColor } },
                            bottom: { style: borderStyle, color: { argb: borderColor } },
                            left: { style: borderStyle, color: { argb: borderColor } },
                            right: { style: borderStyle, color: { argb: borderColor } }
                        };

                        cell.fill = {
                            type: 'pattern',
                            pattern: 'solid',
                            fgColor: { argb: 'FFD9EAF7' } // light grey
                        };

                        cell.alignment = {
                            vertical: 'middle',
                            horizontal: 'center'
                        };
                    }
                }

                const isHeaderRow = rowIndex >= headerStartExcelRow && rowIndex <= headerEndExcelRow;
                const isStudentHeadlineRow = rowIndex === studentHeadlineRowIndex;
                const fillColor =
                    rowIndex >= 8
                        ? (rowIndex - 8) % 2 === 0
                            ? oddFill
                            : evenFill
                        : oddFill;
                const row = worksheet.getRow(rowIndex);

                for (let colIndex = 1; colIndex <= columnCount && rowIndex >= 8; colIndex++) {
                    const cell = row.getCell(colIndex);
                    cell.fill = {
                        type: 'pattern',
                        pattern: 'solid',
                        fgColor: { argb: fillColor }
                    };
                    cell.border = {
                        top: { style: borderStyle, color: { argb: borderColor } },
                        bottom: { style: borderStyle, color: { argb: borderColor } },
                        left: { style: borderStyle, color: { argb: borderColor } },
                        right: { style: borderStyle, color: { argb: borderColor } }
                    };
                    if (isHeaderRow) {
                        cell.font = {
                            bold: true,
                            color: { argb: isStudentHeadlineRow ? 'FF000000' : headerFontColor }
                        };
                        cell.alignment = {
                            vertical: 'middle',
                            horizontal: 'center',
                            wrapText: true
                        };
                    }
                }
            }

            const fileName = `proficiency ${dayjs().format("DD-MM-YY hh:mm:ss")}.xlsx`;
            const buffer = await workbook.xlsx.writeBuffer();
            const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            saveAs(blob, fileName);

            if (currentClass?.id && currentUser?.id) {
                dispatch(handleCreateDownloadList({
                    title: fileName,
                    url: fileName,
                    class_id: selectedClassId ? selectedClassId : currentClass.id,
                    created_by: currentUser.id
                }));
            }
        } catch (error) {
            Sentry.captureException(`Error in exam gradebook download: ${error}`);
            console.error("Error in exam gradebook download:", error);
        }
    }

    const generateCSV = async () => {
        const rows = [];
        if (isCombined) {
            const combinedHeaders = ['Name', 'Username', 'Student Id', 'Teacher Name', 'School Name', 'Exam 1 Placement', 'Exam 2 Placement', 'Exam 3 Placement'];
            EXAM_LABELS_FULL.forEach((label) => {
                combinedHeaders.push(`${label} (Exam 1)`);
                combinedHeaders.push(`${label} (Exam 2)`);
                combinedHeaders.push(`${label} (Exam 3)`);
            });
            rows.push(combinedHeaders);

            (filteredStudent || []).forEach(({ user, submissions }) => {
                const placementData = submissions?.[0] || {};
                const row = [
                    `${user?.lastName || ""}, ${user?.firstName || ""}`,
                    user?.username || '',
                    user?.studentId || '',
                    user?.teacherName || '',
                    user?.schoolName || '',
                    placementData.exam1 || '-',
                    placementData.exam2 || '-',
                    placementData.exam3 || '-',
                ];
                EXAM_LABELS_FULL.forEach((_, i) => {
                    const sectionData = submissions?.[i + 1] || {};
                    row.push(sectionData.exam1 || '-');
                    row.push(sectionData.exam2 || '-');
                    row.push(sectionData.exam3 || '-');
                });
                rows.push(row);
            });
        } else {
            const headers = ['Name', 'Username', 'Student Id', 'Teacher Name', 'School Name', 'Placement', 'Overall score', 'Overall Points possible', 'Overall Points earned'];
            EXAM_LABELS_FULL.forEach((label) => {
                headers.push(`${label} overall score`);
                headers.push(`${label} Overall points possible`);
                headers.push(`${label} Overall points earned`);
            });
            rows.push(headers);

            (filteredStudent || []).forEach(({ user, submissions, grades_value = [] }) => {
                const overallData = grades_value?.[0] || {};
                const row = [
                    `${user?.lastName || ""}, ${user?.firstName || ""}`,
                    user?.username || '',
                    user?.studentId || '',
                    user?.teacherName || '',
                    user?.schoolName || '',
                    submissions?.[0] || '-',
                    overallData.overall_score ?? '-',
                    overallData.Overall_Points_possible ?? '-',
                    overallData.Overall_Points_earned ?? '-',
                ];
                EXAM_LABELS_FULL.forEach((_, i) => {
                    const sectionData = grades_value?.[i + 1] || {};
                    row.push(sectionData.overall_score ?? '-');
                    row.push(sectionData.Overall_Points_possible ?? '-');
                    row.push(sectionData.Overall_Points_earned ?? '-');
                });
                rows.push(row);
            });
        }

        const toCsvCell = (value) => {
            if (value === null || value === undefined) return '';
            const text = String(value).replace(/"/g, '""');
            if (/[",\n]/.test(text)) {
                return `"${text}"`;
            }
            return text;
        };

        const csvContent = rows.map((row) => row.map(toCsvCell).join(',')).join('\n');
        const { saveAs } = await import('file-saver');
        const fileName = `${isCombined ? 'combined_proficiency' : 'proficiency'} ${dayjs().format("DD-MM-YY hh:mm:ss")}.csv`;
        const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
        saveAs(blob, fileName);

        if (currentClass?.id && currentUser?.id) {
            dispatch(handleCreateDownloadList({
                title: fileName,
                url: fileName,
                class_id: selectedClassId ? selectedClassId : currentClass.id,
                created_by: currentUser.id
            }));
        }
    };

    const downloadNav = () => {
        return {
            items: [
                {
                    key: "XLSX",
                    label: (
                        <PaddedBtn onClick={() => generateXLSX()}>
                            XLSX
                        </PaddedBtn>
                    ),
                    style: { padding: '0px' }
                },
                {
                    key: "csv",
                    label: (
                        <PaddedBtn onClick={() => generateCSV()}>
                            CSV
                        </PaddedBtn>
                    ),
                    style: { padding: '0px' }
                }
            ]
        };
    }
    const menuData = () => {
        return {
            items: map(Object.keys(groupBy(exams, "session")), x => ({
                key: x,
                label: <PaddedBtn onClick={() => setActiveSession(x)}>{x}</PaddedBtn>,
                style: { padding: '0px' }
            }))
        }
    }

    const userClasses = useUserClasses();

    const classNav = () => {
        return {
            items: map(userClasses, (x) => {
                if (!x?.displayName) return null;
                if (get(x, 'archived', false)) return null;
                const isSelected = selectedClassId === x.id;
                return {
                    key: x.id,
                    label: (
                        <PaddedBtn
                            onClick={async () => {
                                setSelectedClassId(x.id);
                                await fetchExamData(activeSession, x.id);
                            }}
                        >
                            {x.displayName}
                        </PaddedBtn>
                    ),
                    style: {
                        color: isSelected ? COLOR.white : COLOR.black100,
                        background: isSelected ? COLOR.indigo100 : "transparent",
                        height: 30
                    }
                };
            }).filter(Boolean)
        };
    };

    return (
        <SentryWrap>
            <Wrapper>
                <SpinLoader dataloader={apiDataLoading} />
                {(dataLoading) ? (
                    <Loading />
                ) : (
                    <div>
                        <ExamGradeSec>

                           <div className={styles.topLayout}>
                            <div className={styles.leftLayout}>
                            <div className={styles.gradeTableTopSection}>
                                <GraphRow className={styles.graphRowWrap}>

                                    <div className={styles.leftMainContent}>

                                        <div className={styles.gradeTableMid}>

                                            <div className={styles.OnwWayAssign}>
                                                <img src={OneWayEducationLogo} alt="OneWayEducation" className={styles.oneWayLogoImg} />
                                                {/* <label className={styles.OnwWayAssignLbl}>Assignment</label> */}
                                            </div>

                                            <div className={styles.assignDropDowns}>

                                                <Dropdown className={styles.examYearDropDown} menu={menuData()} placement="bottomLeft" trigger={['click']}>
                                                    <Button className={styles.toolbarButton} onClick={e => e.preventDefault()}>
                                                        {activeSession ? activeSession : 'sessions'}
                                                        <img src={SelectDownArrow} alt="" aria-hidden="true" style={{ width: '10px', marginLeft: '6px' }} />
                                                    </Button>
                                                </Dropdown>

                                                <Dropdown className={`${styles.examYearDropDown} ${styles.examClassDropDown}`} menu={classNav()} placement="bottomLeft" trigger={['click']}>
                                                    <Button className={styles.toolbarButton} onClick={e => e.preventDefault()}>
                                                        <span className='flex items-center' style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                                        <MenuBook style={{ fontSize: 16, marginRight: 6 }} />
                                                            {find(userClasses, (x) => x.id === selectedClassId)?.displayName}
                                                        </span>
                                                        <img src={SelectDownArrow} alt="" aria-hidden="true" style={{ width: '10px', marginLeft: '6px' }} />
                                                    </Button>
                                                </Dropdown>

                                                <Select className={styles.examSchoolDropDown} defaultValue={examSchool} value={examSchool} dropdownStyle={{ minWidth: 140 }} suffixIcon={<img src={SelectDownArrow} alt="" aria-hidden="true" style={{ width: '10px', marginLeft: '6px' }} />} onChange={v => {
                                                    setExamSchool(v);
                                                }}>
                                                    {EXAM_SCHOOLS.map((key) => (
                                                        <Option key={key} value={key}>
                                                            <span className={styles.examSchoolOptionText}>{String(key).toLowerCase()}</span>
                                                        </Option>
                                                    ))}
                                                </Select>

                                                <Select className={styles.examDropDown} defaultValue={examType} dropdownStyle={{ minWidth: 140 }} suffixIcon={<img src={SelectDownArrow} alt="" aria-hidden="true" style={{ width: '10px', marginLeft: '6px' }} />} onChange={v => {
                                                    onExamTabClick(v);
                                                }}>
                                                    <Option value="exam1">Exam1</Option>
                                                    <Option value="exam2">Exam2</Option>
                                                    <Option value="exam3">Exam3</Option>
                                                    <Option value="combined">Combined</Option>
                                                </Select>

                                                <Dropdown className={styles.apExamSelect} menu={activeInactiveNav()} placement="bottomLeft" trigger={['click']}>
                                                    <StudentStatusSelector onClick={(e) => e.preventDefault()}>
                                                        <span>
                                                            {typeof activeInactive === 'string'
                                                                ? activeInactive.charAt(0).toUpperCase() + activeInactive.slice(1)
                                                                : 'Active'}{' '}
                                                            students
                                                        </span>
                                                        <img src={SelectDownArrow} alt="" aria-hidden="true" style={{ width: '10px', marginLeft: '5px' }} />
                                                    </StudentStatusSelector>
                                                </Dropdown>

                                                <div className={styles.OvrAllGrph}>
                                                    <OverallModal selectedClassId={selectedClassId} examSchool={examSchool} examType={examType} selectedActiveSession={activeSession} />
                                                </div>
                                                <ReportButton onClick={() => navigate('/proficiency-report', {
                                                    state: {
                                                        returnTo: '/admin/class?view=gradebook',
                                                        openGradebookExam: true,
                                                        examTab: examType || 'exam1',
                                                        selectedClassId: selectedClassId || currentClass?.id,
                                                    },
                                                })}>
                                                    Report
                                                </ReportButton>
                                                <Dropdown className={styles.overAllDownload} menu={downloadNav()} placement="bottomLeft" trigger={['click']}>
                                                    <Button className={styles.toolbarButton} onClick={e => e.preventDefault()}>
                                                        Download
                                                        <DownloadOutlined style={{ marginLeft: '8px' }} />
                                                    </Button>
                                                </Dropdown>

                                            </div>
                                        </div>

                                        <div className={styles.totalLeftSection}>
                                            <div className={styles.overviewCol}>
                                                <div className={styles.overviewCard}>
                                                    <div className={styles.numberSection}>
                                                     <div>   
                                                     <span className={styles.overviewTitle}>Overview</span>
                                                     <TotalNStudentTxt className={styles.totalStudentsTxt}>
                                                        Total number of student :
                                                     </TotalNStudentTxt>
                                                     </div>
                                                     <span className={styles.totalStudentsValue}>{filteredStudent.length}</span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className={styles.chartCol}>
                                                <div className={styles.chartCard}>
                                                    <div className={styles.chartScrollArea}>
                                                        <ChartContainer className={styles.chartContainerTrack}>
                                                            {map(ACIFL_LEVEL.slice(0, -1), k => {
                                                                const chartData = getChartConfig(k);
                                                                return (
                                                                    <ChartContainerInner key={k} className={styles.chartItem}>
                                                                        <div className={styles.chartFrame} style={{ width: chartConfig.width, height: chartConfig.height }}>
                                                                            <PieChart width={chartConfig.width} height={chartConfig.height}>
                                                                                <Pie
                                                                                    data={chartData.data}
                                                                                    cx="50%"
                                                                                    cy="50%"
                                                                                    outerRadius={chartConfig.outerRadius}
                                                                                    innerRadius={chartConfig.innerRadius}
                                                                                    startAngle={chartConfig.startAngle}
                                                                                    endAngle={chartConfig.endAngle}
                                                                                    paddingAngle={0}
                                                                                    dataKey="value"
                                                                                    nameKey="name"
                                                                                    stroke="none"
                                                                                    label={false}
                                                                                >
                                                                                    {chartData.data.map((entry, index) => (
                                                                                        <Cell key={`cell-${index}`} fill={entry.fill} />
                                                                                    ))}
                                                                                </Pie>
                                                                            </PieChart>
                                                                            <div className={styles.chartCenterValue} style={chartConfig.titleStyle}>
                                                                                {chartData.title}
                                                                            </div>
                                                                        </div>
                                                                        <ChartLabel className={styles.chartLabel}>{k}</ChartLabel>
                                                                    </ChartContainerInner>
                                                                );
                                                            })}
                                                        </ChartContainer>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                    </div>

                                </GraphRow>

                            </div>

                            <div className={styles.faltantesCol}>
                                    <div className={styles.faltantesCard}>
                                        {(() => {
                                            const faltantesKey = ACIFL_LEVEL[ACIFL_LEVEL.length - 1];
                                            const faltantesData = getChartConfig(faltantesKey);
                                            return (
                                                <>
                                                        <div className={styles.faltantesChartWrap}>
                                                            <PieChart width={165} height={75}>
                                                            <Pie
                                                                data={faltantesData.data}
                                                                cx="50%"
                                                                cy="100%"
                                                                    outerRadius={50}
                                                                    innerRadius={39}
                                                                startAngle={180}
                                                                endAngle={0}
                                                                paddingAngle={0}
                                                                dataKey="value"
                                                                nameKey="name"
                                                                stroke="none"
                                                                label={false}
                                                            >
                                                                {faltantesData.data.map((entry, index) => (
                                                                    <Cell key={`faltantes-cell-${index}`} fill={index === 0 ? '#ff0000' : '#ffd7d7'} />
                                                                ))}
                                                            </Pie>
                                                        </PieChart>
                                                        <div className={styles.faltantesCenterValue}>{faltantesData.title}</div>
                                                    </div>
                                                    <div className={styles.faltantesLabel}>FALTANTES</div>
                                                </>
                                            );
                                        })()}
                                    </div>
                            </div>

                            </div>

                            <div className={styles.rightLayout}>
                                <div className={styles.rightLayoutActions}>
                                <Button
                                    className={styles.toolbarButton}
                                    disabled={apiDataLoading}
                                    onClick={(e) => {
                                        e.preventDefault();
                                        e.stopPropagation();
                                        handleRefreshExamData();
                                    }}
                                 >
                                    <ReloadOutlined  style={{ fontSize: '15px', fontWeight: 'bold'}}  spin={apiDataLoading} /> <span style={{ whiteSpace: 'nowrap' , marginLeft: '8px' }}>Refresh</span>
                                </Button>
                                <div  style={{ cursor: 'pointer', display: 'flex', alignItems: 'center', flexWrap: 'nowrap' }}>
                                     <CancelOutlined onClick={onClose} sx={{ fontSize: 20, color:'red' }} className={styles.closeOutline} />
                                </div>
                                </div>
                            </div>

                          </div>

                          <div className={styles.findStudentSrch}>
                                    <label className={styles.findStudentLabel}>Find your student</label>
                                    <SearchBoxContainer className={styles.findStudentInputWrap}>
                                        <Search className={styles.searchIcon} />
                                        <SearchBox
                                            className={styles.findStudentInput}
                                            placeholder="Search..."
                                            value={studentSearch}
                                            onChange={filterStudent}
                                        />
                                    </SearchBoxContainer>
                                </div>

                              <div className={styles.ExamOverflowTwoUpr} style={{ display: "flex", flex: 1 }}>
                                <ExamOverflowTwo>
                                    <ExamGradeTable className={styles.ExamGradeTableCstm}>
                                        <ExamGradeBoday>
                                            <Exam2TableHeader>
                                                <ExamTableSection1 style={{ width: 220 }}>
                                                    <NameContent>Name</NameContent>
                                                </ExamTableSection1>
                                                <ExamTableSection2>
                                                    <TopTabCont>
                                                        <TableTopBtnCont style={{ width: 140 }}>
                                                            <HeaderTabP>Placement</HeaderTabP>
                                                        </TableTopBtnCont>
                                                        {map(EXAM_LABELS, (key, index) => (<TableTopBtnCont key={key + index} style={{ width: getWidth(index) }}>
                                                            <TootipWrapper hasToolTip label={EXAM_LABELS_FULL[index]}>
                                                                <HeaderTab key={key} style={{ fontSize: 12, textOverflow: "ellipsis", width: "90%", borderRadius: '10px' }}>{key}</HeaderTab>
                                                            </TootipWrapper>
                                                        </TableTopBtnCont>
                                                        ))}
                                                    </TopTabCont>
                                                </ExamTableSection2>
                                            </Exam2TableHeader>
                                        </ExamGradeBoday>
                                    </ExamGradeTable>
                                    {modal && (
                                        <>
                                        <Modal open={modal} onClose={handleExamGradeModalClose} disableEnforceFocus>
                                            <ModalRndAnchor tabIndex={-1}>
                                            <Rnd
                                                key={selectedStudent?.id != null ? String(selectedStudent.id) : 'exam-eye-modal'}
                                                default={examGradeEyeRndDefault}
                                                bounds="window"
                                                enableResizing={false}
                                                dragHandleClassName="exam-grade-modal-drag-handle"
                                                cancel=".exam-grade-modal-close, .exam-grade-modal-close *, .exam-grade-flag-trigger, .exam-grade-flag-trigger *, [data-exam-grade-flag-trigger], [data-exam-grade-flag-trigger] *, .exam-grade-print-trigger, .exam-grade-print-trigger *"
                                                style={{ zIndex: 1301 }}
                                            >
                                                <ModalWrapper onClick={(e) => e.stopPropagation()}>
                                                    <PrintContent ref={printRef} className="to_be_print print-content-row">
                                                    <ModalTopDragHandle className="exam-grade-modal-drag-handle" />
                                                    <CloseButtonWrapper className="exam-grade-modal-close">
                                                        <CloseIcon onTouchStart={toggleModal} onClick={toggleModal} style={{ width: 20, height: 20, color: "white" }} />
                                                    </CloseButtonWrapper>
                                                        {loading ? (
                                                            <>
                                                                <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', marginTop: '8px' }}>
                                                                    <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', flex: 1 }}>
                                                                        <Skeleton.Input active size="small" style={{ width: '200px', height: '20px' }} />
                                                                        <Skeleton.Input active size="small" style={{ width: '150px', height: '16px' }} />
                                                                    </div>
                                                                    <Skeleton.Avatar active size={25} shape="circle" />
                                                            </div>
                                                            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'flex-start', flexWrap: 'wrap', justifyContent: 'flex-start', marginTop: '5px' }}>
                                                                <div style={{ width: '50%', minWidth: 0, flex: '1 1 50%', maxWidth: '50%' }}>
                                                                    <Skeleton active title={false} paragraph={{ rows: 1, width: '60%' }} style={{ marginBottom: '10px' }} />
                                                                    <Skeleton.Input active style={{ width: '100%', height: '20px', marginBottom: '10px' }} />
                                                                    <Skeleton active title={false} paragraph={{ rows: 1, width: '80%' }} style={{ marginBottom: '15px' }} />
                                                                    <div style={{ display: 'flex', flexDirection: 'row', gap: '10px', flexWrap: 'wrap' }}>
                                                                        <Skeleton.Input active style={{ width: '150px', height: '28px', borderRadius: '38px' }} />
                                                                        <Skeleton.Input active style={{ width: '180px', height: '28px', borderRadius: '38px' }} />
                                                                    </div>
                                                                </div>
                                                                <ExamPerformanceChartWrap style={{ position: 'relative', zIndex: 0, pointerEvents: 'none' }}>
                                                                    <div style={{ flexBasis: '50%', flexShrink: 0, flexGrow: 0, pointerEvents: 'auto', width: '100%' }}>
                                                                        <ChartWrap>
                                                                            <Skeleton active title={false} paragraph={{ rows: 1, width: '50%' }} style={{ marginBottom: '12px' }} />
                                                                            <Skeleton active title={false} paragraph={{ rows: 6, width: ['100%', '95%', '90%', '85%', '80%', '75%'] }} />
                                                                        </ChartWrap>
                                                                    </div>
                                                                </ExamPerformanceChartWrap>
                                                            </div>
                                                            </>
                                                        ) : (
                                                            <>
                                                                <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', marginTop: '8px' }}>
                                                                    <div style={{ display: 'flex', flexDirection: 'column', gap: '1px', lineHeight: '1.2' }}>
                                                                        <p style={{ fontSize: '14px', fontWeight: '600', color: '#252525', margin: '0px' }}>
                                                                            {studentData?.studentData ? `${studentData.studentData.firstName} ${studentData.studentData.lastName} (Student)` : selectedStudent ? `${selectedStudent.firstName} ${selectedStudent.lastName} (Student)` : '(Student)'}
                                                                        </p>
                                                                        <p style={{ fontSize: '12px', fontWeight: '400', color: '#9CA3AF', margin: '0px' }}>
                                                                            {studentData?.studentData?.schoolName || ''}
                                                                        </p>
                                                                    </div>
                                                                    <PrintButtonWrapper className="exam-grade-print-trigger" onTouchStart={handlePrint} onClick={handlePrint}>
                                                                        <PrintIcon sx={{ width: '18px', height: '18px' }} />
                                                                    </PrintButtonWrapper>
                                                                </div>
                                                            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'flex-start', flexWrap: 'wrap', justifyContent: 'flex-start', marginTop: '5px' }}>
                                                                <div style={{ width: '50%', minWidth: 0, position: 'relative', zIndex: 60, isolation: 'isolate' }}>
                                                                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', justifyContent: 'flex-start', gap: '5px' }}>
                                                                        <p style={{ fontSize: '14px', fontWeight: '600', margin: '0' }} >Overall Performance</p>
                                                                        <progress className="pill-progress" id="file" value={studentData?.overallPerformance || 0} max="100"> {studentData?.overallPerformance || 0}% </progress>
                                                                        <p style={{ fontSize: '12px', fontWeight: '400', margin: '0px' }}>
                                                                            {studentData?.band ? `Received a target of ${studentData.band} in a Exam ${examType === 'exam1' ? '1' : examType === 'exam2' ? '2' : examType === 'exam3' ? '3' : ''}.` : 'No data available'}
                                                                        </p>
                                                                        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', gap: '10px' }}>
                                                                            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', backgroundColor: getPriorityColor(studentData?.overallPerformance || 0), padding: '2px 10px', borderRadius: '38px' }}>
                                                                                <p style={{ fontSize: '12px', color: '#fff', lineHeight: '1.2', padding: '2px 4px', margin: '0' }}>{getPriorityText(studentData?.overallPerformance || 0)}</p>
                                                                                <button
                                                                                    type="button"
                                                                                    data-exam-grade-flag-trigger
                                                                                    className="exam-grade-flag-trigger"
                                                                                    aria-label="Open flag system"
                                                                                    onMouseDown={(e) => {
                                                                                        e.stopPropagation();
                                                                                        openExamFlagLegend();
                                                                                    }}
                                                                                    onClick={(e) => {
                                                                                        e.stopPropagation();
                                                                                        openExamFlagLegend();
                                                                                    }}
                                                                                    style={{ border: 'none', background: 'transparent', padding: 0, display: 'inline-flex', alignItems: 'center', cursor: 'pointer', verticalAlign: 'middle' }}
                                                                                >
                                                                                    <InfoOutlineIcon sx={{ color: '#000', width: '20px', height: '20px', pointerEvents: 'none' }} />
                                                                                </button>
                                                                            </div>
                                                                            <div style={{ border: '1px solid #000', display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', backgroundColor: '#fff', padding: '2px 10px', borderRadius: '38px' }}>
                                                                                <p style={{ fontSize: '12px', color: '#000', lineHeight: '1.2', padding: '2px 4px', margin: '0' }}>Compared to District Avg:-{studentData?.districtOverallPerformance || 0}%</p>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <ExamPerformanceChartWrap style={{ position: 'relative', zIndex: 0, pointerEvents: 'none' }}>
                                                                    <div style={{ flexBasis: '50%', flexShrink: 0, flexGrow: 0, pointerEvents: 'auto' }}>
                                                                        <ChartWrap>
                                                                            <p style={{ fontSize: '14px', fontWeight: '600', margin: '0', textAlign: 'center' }} >Domains Needing Support</p>
                                                                            <DomainsPerformanceChart data={domainsChartData} />
                                                                        </ChartWrap>
                                                                    </div>
                                                                </ExamPerformanceChartWrap>
                                                            </div>
                                                            </>
                                                        )}
                                                    </PrintContent>
                                                </ModalWrapper>
                                            </Rnd>
                                            </ModalRndAnchor>
                                        </Modal>
                                        {openFlagModal &&
                                            createPortal(
                                                <FlagPortalSurface>
                                                    <Rnd
                                                        key={selectedStudent?.id != null ? `exam-flag-${selectedStudent.id}` : 'exam-flag'}
                                                        default={examGradeFlagRndDefault}
                                                        bounds="window"
                                                        enableResizing={false}
                                                        dragHandleClassName="flag-modal-drag-handle"
                                                        cancel=".flag-modal-close, .flag-modal-close *"
                                                    >
                                                        <FlagModalWrapper>
                                                            <FlagModalDragHandle className="flag-modal-drag-handle" />
                                                            <div className="flag-modal-close" style={{ position: 'absolute', top: 8, right: 8, zIndex: 10, cursor: 'pointer', backgroundColor: 'red', borderRadius: '100%', width: '24px', height: '24px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                                <CloseIcon onTouchStart={closeExamFlagLegend} onClick={closeExamFlagLegend} style={{ width: 20, height: 20, color: "white" }} />
                                                            </div>
                                                            <div className="flagExamGradeTable" style={{ paddingTop: '48px' }}>
                                                                <p style={{ fontSize: '20px', fontWeight: '600', color: '#fff', margin: '0px' }}>Flag System</p>
                                                                <ul>
                                                                    {flagData.map((item, index) => {
                                                                        return (
                                                                            <li key={index} style={{ margin: 0, color: '#fff', fontSize: 14, fontWeight: 600, marginLeft: '20px' }}>
                                                                                <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                                                                                    <span style={{ width: 18, height: 18, borderRadius: 3, background: item.backgroundcolor }} />
                                                                                    <span style={{ flex: 1 }}>
                                                                                        {item.title}
                                                                                    </span>
                                                                                </div>
                                                                            </li>
                                                                        )
                                                                    })}
                                                                </ul>
                                                            </div>
                                                        </FlagModalWrapper>
                                                    </Rnd>
                                                </FlagPortalSurface>,
                                                document.body
                                            )}
                                        </>
                                    )}
                                    {!isCombined ? <ViewGradeTable
                                        filteredusers_response={filteredStudent}
                                        question_length={apiData.question_length}
                                        toggleModal={toggleModal}
                                        examType={examType}
                                    /> : <ViewGradeTableCombine
                                        toggleModal={toggleModal}
                                        filteredusers_response={filteredStudent}
                                        question_length={apiDataCombine.question_length}
                                    />}
                                </ExamOverflowTwo>
                            </div>

                        </ExamGradeSec>
                    </div>
                )}
            </Wrapper>
        </SentryWrap>
    );
};


export default ExamTable;
